import React from 'react'

const dictionaries = {
  fr: {
    common: {
      loading: 'Chargement...',
      openingAttachment: 'Ouverture du fichier…',
      attachmentOpenError: 'Impossible d’ouvrir le fichier. Vérifiez votre connexion puis touchez le fichier pour réessayer.',
      attachmentNoViewer: 'Aucune application ne peut ouvrir ce format. Installez un lecteur compatible puis réessayez.',
      cancel: 'Annuler',
      back: '← Retour',
      close: 'Fermer',
      save: 'Sauvegarder',
      saving: 'Sauvegarde...',
      sending: 'Envoi...',
      upload: 'Upload...',
      upgrade: 'Upgrader →',
      viewPlans: 'Voir les plans →',
      viewProfile: 'Voir le profil →',
      companyNotFound: 'Profil introuvable',
      free: 'Gratuit',
      month: '/mois',
      currentPlan: 'Plan actuel',
    },
    nav: {
      home: 'Accueil',
      swipe: 'Swipe',
      newCompanies: count => `${count} ${count === 1 ? 'nouvelle entreprise' : 'nouvelles entreprises'}`,
      map: 'Carte',
      messages: 'Messages',
      profile: 'Profil',
      pricing: 'Tarifs',
    },
    usageGuide: {
      usageGuide: "Mode d'emploi",
      usageGuideTitle: "Mode d'emploi Hubbing",
      usageGuideIntro: 'Un repère rapide pour comprendre les menus et retrouver les fonctions principales.',
      usageGuideBack: 'Retour',
      usageGuideClose: "Fermer le mode d'emploi",
      usageGuideSteps: [
        { title: 'Accueil', body: 'Retrouvez votre résumé, votre profil et les prochaines actions importantes.' },
        { title: 'Swipe', body: 'Parcourez les entreprises, filtrez par secteur, canton, rayon ou besoin, puis matchez les bons partenaires.' },
        { title: 'Carte', body: 'Visualisez les entreprises suisses autour de vous et ouvrez leur profil depuis la carte.' },
        { title: 'Messages', body: 'Échangez avec vos connexions, suivez les messages lus et gardez vos conversations organisées.' },
        { title: 'Profil', body: 'Mettez à jour vos informations, vos besoins B2B, vos visuels et vos préférences.' },
        { title: 'Tarifs', body: 'Comparez Starter, Basic et Premium pour choisir le niveau adapté à votre visibilité.' },
      ],
      usageGuidePages: [
        {
          title: 'Accueil',
          icon: 'home',
          color: '#E24B4A',
          summary: "La page d'accueil sert de tableau de bord. Elle vous montre l'état de votre compte, vos connexions et les actions importantes à faire.",
          sections: [
            {
              title: 'Ce que vous voyez',
              items: [
                "Le résumé de votre activité sur Hubbing, comme vos connexions, vos messages et les informations importantes de votre profil.",
                "Les étapes de démarrage si votre profil n'est pas encore complet : logo, photo, besoins B2B, informations entreprise et plan.",
                "Des raccourcis vers les actions utiles pour améliorer votre visibilité auprès des autres entreprises.",
              ],
            },
            {
              title: 'Comment l’utiliser',
              items: [
                "Commencez par vérifier si une action est demandée sur votre profil ou votre abonnement.",
                "Utilisez les raccourcis pour compléter les informations manquantes avant de chercher des partenaires.",
                "Revenez sur cette page après vos matchs pour garder une vue simple de votre activité.",
              ],
            },
            {
              title: 'Bonnes pratiques',
              items: [
                "Un profil avec logo, description claire et besoins actuels inspire davantage confiance.",
                "Mettez à jour vos besoins quand vous cherchez réellement un partenaire, un fournisseur ou un service.",
                "Si votre entreprise vient d’être validée, vérifiez que vos informations publiques sont propres avant de commencer à matcher.",
              ],
            },
          ],
        },
        {
          title: 'Swipe',
          icon: 'swipe',
          color: '#185FA5',
          summary: 'Le Swipe permet de découvrir rapidement des entreprises et de créer des connexions B2B avec celles qui correspondent à vos besoins.',
          sections: [
            {
              title: 'Fonctionnement',
              items: [
                "Chaque carte présente une entreprise avec son secteur, sa ville, son plan, son badge et ses besoins B2B s'ils sont renseignés.",
                "Vous pouvez passer une entreprise, montrer votre intérêt ou revenir sur la carte précédente avec le bouton de retour.",
                "Quand deux entreprises montrent un intérêt mutuel, une connexion peut être créée pour ouvrir l'échange.",
              ],
            },
            {
              title: 'Filtres disponibles',
              items: [
                "Le filtre secteur permet de cibler un domaine précis comme BTP, fiduciaire, informatique ou nettoyage.",
                "Le filtre canton limite les cartes à une région suisse précise.",
                "Le filtre rayon utilise votre position ou celle de votre profil pour afficher les entreprises proches.",
                "La recherche par besoin permet d’écrire un mot comme résine, comptable ou site web pour trouver les entreprises qui ont indiqué ce besoin.",
              ],
            },
            {
              title: 'À savoir',
              items: [
                "Les entreprises sont triées pour mettre en avant les profils les plus complets et actifs, puis les cartes démo arrivent après les vraies entreprises.",
                "Un besoin cliquable peut vous aider à démarrer une conversation avec un contexte précis.",
                "Si aucun résultat ne s’affiche, élargissez le rayon, changez de canton ou videz la recherche par besoin.",
              ],
            },
          ],
        },
        {
          title: 'Carte',
          icon: 'map',
          color: '#16A34A',
          summary: 'La carte vous aide à visualiser les entreprises suisses autour de vous et à ouvrir rapidement leur profil.',
          sections: [
            {
              title: 'Ce que la carte affiche',
              items: [
                "Les entreprises inscrites sur Hubbing avec leur position approximative ou leur adresse selon les informations disponibles.",
                "Votre position si vous l’autorisez, afin de mieux utiliser le filtre par rayon.",
                "Un marqueur de sélection quand vous choisissez une entreprise sur la carte.",
              ],
            },
            {
              title: 'Recherche et filtres',
              items: [
                "La barre de recherche permet de trouver une entreprise, une ville ou un secteur.",
                "Les filtres secteur, canton et rayon réduisent la carte aux entreprises les plus pertinentes.",
                "Le rayon peut être ajusté par kilomètres pour chercher proche de vous ou sur une zone plus large.",
              ],
            },
            {
              title: 'Utilisation pratique',
              items: [
                "Touchez une entreprise pour ouvrir sa fiche rapide, puis son profil complet selon votre plan.",
                "Utilisez la carte pour repérer les partenaires locaux avant de les contacter depuis Swipe ou Messages.",
                "Si plusieurs entreprises sont dans la même zone, zoomez pour mieux les distinguer.",
              ],
            },
          ],
        },
        {
          title: 'Messages',
          icon: 'messages',
          color: '#7C3AED',
          summary: 'La messagerie sert à échanger avec les entreprises connectées, suivre les discussions et garder un historique clair.',
          sections: [
            {
              title: 'Organisation',
              items: [
                "Les conversations récentes et les messages non lus sont mis en avant pour ne pas manquer une réponse.",
                "La recherche permet de retrouver une conversation par nom d’entreprise, secteur, ville ou contenu récent.",
                "Les indicateurs d’envoi et de lecture vous aident à comprendre l’état de vos messages.",
              ],
            },
            {
              title: 'Échanger efficacement',
              items: [
                "Présentez rapidement votre besoin, votre délai et ce que vous attendez de l’autre entreprise.",
                "Depuis certains besoins, le message peut être préparé avec le sujet pour donner du contexte.",
                "Vous pouvez ouvrir le profil de l’entreprise depuis la conversation pour relire ses informations.",
              ],
            },
            {
              title: 'Règles importantes',
              items: [
                "Le plan Starter limite l’envoi de messages, mais la réception reste possible.",
                "Les coordonnées externes peuvent être bloquées dans la messagerie pour éviter le contournement des règles.",
                "Gardez les échanges professionnels : les contenus abusifs, sexuels, racistes ou inappropriés peuvent être refusés.",
              ],
            },
          ],
        },
        {
          title: 'Profil',
          icon: 'profile',
          color: '#F59E0B',
          summary: 'Le profil est votre vitrine. C’est ici que vous mettez à jour les informations vues par les autres entreprises.',
          sections: [
            {
              title: 'Informations principales',
              items: [
                "Vous pouvez modifier le nom public, le secteur, la ville, l’adresse, la description et les informations de contact.",
                "Le logo, le fond et la photo du décideur rendent votre profil plus crédible et plus reconnaissable.",
                "Le statut de vérification indique si votre entreprise a été validée automatiquement via Zefix ou manuellement par Hubbing.",
              ],
            },
            {
              title: 'Besoins B2B',
              items: [
                "Ajoutez vos besoins actuels pour indiquer ce que vous recherchez : fournisseur, partenaire, service, matériel ou compétence.",
                "Une échéance peut être ajoutée pour montrer si le besoin est urgent ou temporaire.",
                "Des besoins précis améliorent les résultats dans Swipe et donnent aux autres entreprises une bonne raison de vous écrire.",
              ],
            },
            {
              title: 'Sécurité et compte',
              items: [
                "Vous pouvez modifier votre mot de passe depuis le profil si vous êtes connecté.",
                "Votre plan actuel est visible depuis le profil et peut vous rediriger vers les tarifs.",
                "La suppression de compte se trouve tout en bas et doit être utilisée avec prudence, surtout si un abonnement App Store est actif.",
              ],
            },
          ],
        },
        {
          title: 'Tarifs',
          icon: 'pricing',
          color: '#0F766E',
          summary: 'La page Tarifs explique les différences entre Starter, Basic et Premium pour choisir le niveau adapté à votre utilisation.',
          sections: [
            {
              title: 'Plans',
              items: [
                "Starter permet de découvrir Hubbing avec les fonctions essentielles et une visibilité de base.",
                "Basic débloque davantage d’échanges et un accès plus confortable aux informations utiles.",
                "Premium offre la visibilité la plus forte, les coordonnées complètes selon les règles du plan et des fonctions plus avancées.",
              ],
            },
            {
              title: 'Abonnement',
              items: [
                "Sur le web, l’abonnement peut passer par Stripe selon le parcours utilisé.",
                "Sur iPhone, les achats et abonnements passent par l’App Store conformément aux règles Apple.",
                "Si vous êtes sur iPhone, vous pouvez restaurer vos achats ou gérer votre abonnement Apple depuis les options prévues.",
              ],
            },
            {
              title: 'Avant de choisir',
              items: [
                "Choisissez Starter si vous voulez tester et compléter votre profil tranquillement.",
                "Choisissez Basic si vous voulez utiliser Hubbing régulièrement pour contacter des entreprises.",
                "Choisissez Premium si votre objectif est d’être plus visible et d’avoir l’expérience la plus complète.",
              ],
            },
          ],
        },
      ],
    },
    home: {
      morning: 'Bonjour',
      afternoon: 'Bon après-midi',
      evening: 'Bonsoir',
      companiesOnHubbing: (count) => `${count} entreprises sur Hubbing`,
      followingLabel: 'Je suis',
      followersLabel: 'Me suivent',
      collaborationsLabel: 'Collabs réussies',
      followersTitle: 'Entreprises qui me suivent',
      followingTitle: 'Entreprises que je suis',
      noFollowers: 'Personne ne vous suit encore',
      noFollowing: 'Vous ne suivez encore aucune entreprise',
      viewAll: 'Voir tout →',
      noConnections: 'Pas encore de connexions',
      discoverCompanies: 'Découvrir des entreprises',
      completeProfile: 'Complétez votre profil',
      completeProfileDesc: 'Un profil complet attire 3x plus de matchs',
      discoverTitle: 'Découvrir des entreprises',
      discoverDesc: 'Swipez et créez des connexions B2B',
      onboardingTitle: 'Bien démarrer sur Hubbing',
      onboardingDesc: 'Complétez ces étapes pour inspirer confiance et recevoir plus de réponses.',
      onboardingProgress: (done, total) => `${done}/${total} étapes`,
      onboardingProfile: 'Compléter le profil entreprise',
      onboardingVisuals: 'Ajouter logo ou photo du décideur',
      onboardingNeeds: 'Publier vos besoins B2B',
      onboardingPlan: 'Choisir le plan adapté',
      onboardingDone: 'Votre compte est prêt',
      opportunitiesTitle: 'Vos opportunités B2B du moment',
      opportunitiesAllowance: (limit, plan) => limit ? `${limit} opportunités visibles / semaine · ${plan}` : `Opportunités illimitées · ${plan}`,
      opportunitiesFilter: 'Filtrer',
      opportunitiesFilterTitle: 'Filtrer les opportunités',
      opportunitiesFilterCount: (count) => `${count} opportunité${count > 1 ? 's' : ''} trouvée${count > 1 ? 's' : ''}`,
      opportunitiesKeyword: 'Mot-clé',
      opportunitiesKeywordPlaceholder: 'Ex: signalétique, comptable, rénovation...',
      opportunitiesRadius: (radius) => `Rayon : ${radius >= 300 ? 'Toute la Suisse' : `${radius} km`}`,
      opportunitiesSector: 'Secteur',
      opportunitiesAllSectors: 'Tous les secteurs',
      opportunitiesCanton: 'Canton',
      opportunitiesAllCantons: 'Tous les cantons',
      opportunitiesReset: 'Réinitialiser',
      opportunitiesShowResults: (count) => `Voir ${count} résultat${count > 1 ? 's' : ''}`,
      opportunitiesEmpty: 'Rien à afficher pour le moment',
      opportunitiesEmptyDesc: "Restez à l'affût : les besoins compatibles apparaîtront ici dès qu'une entreprise publie une opportunité.",
      opportunitiesUpgradeHint: (count) => `${count} opportunité${count > 1 ? 's' : ''} de plus avec un plan supérieur →`,
      opportunityNeed: 'Besoin',
      opportunityDistance: (km) => `${km} km`,
      opportunityAttachments: (count) => `${count} fichier${count > 1 ? 's' : ''}`,
    },
    map: {
      createAccount: 'Créer un compte →',
      login: 'Se connecter →',
      searchPlaceholder: 'Rechercher une entreprise, secteur, ville...',
      allCantons: 'Tous les cantons',
      allSectors: (count) => `Tous les secteurs (${count} entreprises)`,
      viewProfile: 'Voir le profil →',
      profileShort: 'Profil',
      directions: 'Itinéraire',
      closeDetails: 'Fermer la fiche',
      addressUnavailable: 'Adresse indisponible',
      straightLineDistance: 'Distance à vol d’oiseau depuis votre entreprise',
      approximateDistance: 'Distance estimée à vol d’oiseau depuis votre entreprise',
      distanceUnavailable: 'Distance indisponible depuis votre entreprise',
      profileBasicOnly: 'Profil détaillé dès Basic →',
      createAccountToContact: (name) => `Créer un compte pour contacter ${name} →`,
      registeredCount: (count) => `${count} entreprise${count > 1 ? 's' : ''} inscrite${count > 1 ? 's' : ''} sur Hubbing`,
      filteredCount: (visible, total) => visible === total ? `${total} entreprise${total > 1 ? 's' : ''} sur la carte` : `${visible} / ${total} entreprise${total > 1 ? 's' : ''} sur la carte`,
      approximatePosition: 'Position approximative',
      standardView: 'Plan',
      satelliteView: 'Satellite',
      radius: (radius) => `Rayon : ${radius >= 300 ? 'Toute la Suisse' : `${radius} km`}`,
      radiusButton: (radius) => radius >= 300 ? 'Suisse' : `${radius} km`,
      allSwitzerland: 'Toute la Suisse',
      radiusNeedsLocation: 'Activez votre position ou sauvegardez votre profil pour filtrer par rayon.',
      useMyLocation: 'Utiliser ma position',
      myLocation: 'Ma position',
      meLabel: 'MOI',
      locating: 'Localisation...',
      locationDenied: 'Localisation refusée. Vous pouvez l’activer dans les réglages du navigateur ou de l’iPhone.',
      locationUnavailable: 'Position indisponible pour le moment.',
    },
    swipe: {
      noResults: 'Aucun résultat pour ces filtres',
      allSeen: 'Vous avez tout vu !',
      noResultsDesc: "Essayez d'élargir le rayon, de changer de secteur ou de chercher un autre besoin.",
      allSeenDesc: 'Vous avez parcouru toutes les entreprises disponibles.',
      clearFilters: 'Effacer les filtres',
      reviewAll: 'Tout revoir depuis le début',
      newOnly: 'Voir uniquement les nouvelles',
      matchSent: 'Match envoyé !',
      matchAlreadyExists: 'Match déjà existant',
      createAccountTitle: 'Créez un compte !',
      signupToSave: 'Inscrivez-vous pour sauvegarder ce match.',
      createAccount: 'Créer un compte →',
      login: 'Se connecter →',
      continueVisitor: 'Continuer en mode visiteur',
      filters: 'Filtres',
      needsSearch: 'Recherche par besoin',
      needsSearchPlaceholder: 'Ex: résine, comptable, site web...',
      radius: (radius) => `Rayon : ${radius >= 300 ? 'Toute la Suisse' : `${radius} km`}`,
      allSwitzerland: 'Toute la Suisse',
      saveProfileRadius: '⚠️ Sauvegardez votre profil pour activer le filtre par rayon',
      sector: 'Secteur',
      allSectors: 'Tous les secteurs',
      canton: 'Canton',
      allCantons: 'Tous les cantons',
      clear: 'Effacer',
      apply: (count) => `Appliquer (${count} résultats)`,
      applyNoCount: 'Appliquer',
      discovery: 'Découverte',
      visitorMode: '👀 Mode visiteur — ',
      visitorCreate: 'Créez un compte',
      visitorSuffix: ' pour sauvegarder vos matches',
      filtersButton: '🎛 Filtres',
      previousCard: 'Carte précédente',
      viewProfile: 'Voir profil',
      shareProfile: 'Partager le profil',
      pass: 'Passer',
      match: 'Matcher',
      newLabel: 'Nouveau',
      needs: 'BESOINS',
      pressCheck: 'Appuyez sur ✓ pour créer un compte',
    },
    messages: {
      title: 'Messages',
      subtitle: 'Vos connexions B2B',
      searchPlaceholder: 'Rechercher une entreprise...',
      noSearchResults: 'Aucune conversation trouvée',
      searchHint: 'Essayez avec le nom, le secteur, la ville ou un mot du dernier message.',
      noConnections: 'Pas encore de connexions',
      noConnectionsDesc: 'Swipez des entreprises pour démarrer des conversations !',
      reviewTitle: (name) => `Évaluer ${name}`,
      ratingLabel: 'Note globale *',
      commentOptional: 'Commentaire (optionnel)',
      commentPlaceholder: 'Décrivez votre expérience avec cette entreprise...',
      moderation: '⚠️ Votre avis sera soumis à modération avant publication. Tout avis abusif entraîne une suspension.',
      editReview: 'Modifier mon avis',
      submitReview: 'Soumettre mon avis',
      evaluate: 'Évaluer',
      startConversation: (name) => `Début de la conversation avec ${name}`,
      introduce: 'Présentez-vous !',
      messagePlaceholder: 'Votre message...',
      sent: 'Envoyé',
      read: 'Lu',
      attachment: 'Pièce jointe',
      youPrefix: 'Vous :',
      today: "Aujourd'hui",
      yesterday: 'Hier',
      needDraft: (subject) => `Besoin : ${subject}\n\n`,
      needSubjectLabel: (subject) => `Sujet du besoin : ${subject}`,
      basicOnly: 'Messagerie disponible dès le plan Basic',
      upgradeBasic: 'Passer au plan Basic →',
      deleteConversation: 'Supprimer la conversation',
      deleteConversationAction: 'Supprimer',
      deleteConversationConfirm: (name) => `Supprimer la conversation avec ${name} ?`,
      deleteConversationError: "Impossible de supprimer la conversation pour le moment.",
      viewProfile: 'Voir le profil →',
      viewProfileShort: 'Profil',
      profileBasicOnly: 'Basic',
      deleteForAllConfirm: 'Supprimer ce message pour tout le monde ?',
      deleteForMeConfirm: 'Supprimer ce message pour vous uniquement ?',
      fileTypeError: 'Type de fichier non autorisé.\n\nFormats acceptés : images (jpg, png, gif, webp), PDF, Word, Excel, PowerPoint.',
      fileSizeError: 'Fichier trop lourd. Taille maximum : 10 MB.',
      fileUploadError: "Erreur lors de l'envoi du fichier.",
      fileBlocked: '⚠️ Fichier bloqué\n\nCette image ne respecte pas les règles de Hubbing. Veuillez choisir une image professionnelle.',
      reviewBlocked: '⚠️ Avis non soumis\n\nVotre commentaire contient du contenu inapproprié.',
      messageBlocked: '⚠️ Message non envoyé\n\nVotre message contient du contenu inapproprié (sexuel, raciste ou abusif).\n\nTout abus peut entraîner la suspension de votre compte.',
      directContactBlocked: "⚠️ Coordonnées bloquées\n\nLes numéros de téléphone, emails et liens externes ne peuvent pas être échangés dans la messagerie Hubbing. Continuez l'échange directement dans l'app.",
      starterDailyLimit: (remaining, max) => remaining > 0
        ? `Starter : ${remaining}/${max} messages restants aujourd'hui`
        : "Starter : limite journalière atteinte",
      starterLimitReached: "Limite journalière atteinte.\n\nVous avez envoyé vos 5 messages gratuits aujourd'hui. Passez à Basic ou Premium pour échanger sans limite.",
      starterLimitPlaceholder: 'Limite journalière atteinte',
      messageTooLong: (limit) => `Message trop long.\n\nCe plan autorise ${limit} caractères maximum par message.`,
    },
    pricing: {
      title: 'Choisissez votre plan',
      subtitle: 'Développez votre réseau B2B en Suisse',
      recommended: 'RECOMMANDÉ',
      recommendedPlain: 'RECOMMANDÉ',
      footer: 'Résiliable à tout moment · Paiement sécurisé · CHF uniquement',
      appleFooter: 'Résiliable à tout moment · Paiement via App Store · CHF uniquement',
      androidFooter: 'Résiliable à tout moment · Paiement via Google Play · CHF uniquement',
      legalLinksTitle: 'Informations légales abonnements',
      termsOfUseEula: 'Conditions d’utilisation (EULA)',
      privacyPolicyLink: 'Politique de confidentialité',
      restorePurchases: 'Restaurer mes achats',
      manageTitle: 'Gestion de votre abonnement',
      manageDesc: 'Consultez, modifiez ou résiliez votre abonnement depuis l’espace de paiement utilisé lors de l’achat.',
      manageSubscription: 'Gérer mon abonnement',
      manageError: 'Impossible d’ouvrir la gestion automatiquement. Vous pouvez nous écrire à contact@hubbing.ch.',
      noStripeSubscription: 'Aucun abonnement Stripe actif trouvé pour ce compte.',
      purchasePending: "Votre achat est en attente de validation.",
      purchaseRestored: 'Achats restaurés avec succès.',
      noPurchaseToRestore: 'Aucun abonnement actif trouvé.',
      appleProductsUnavailable: 'Les abonnements Apple ne sont pas encore disponibles. Vérifiez les produits dans App Store Connect.',
      androidBillingUnavailable: 'Les abonnements Google Play ne sont pas encore disponibles. Vérifiez les produits dans Play Console.',
      androidVerificationFailed: "Google Play n'a pas pu confirmer cet abonnement. Réessayez ou restaurez vos achats.",
      downgradeScheduled: 'Votre passage à Basic est programmé pour la prochaine date de facturation.',
      purchaseSuccess: (plan) => `Abonnement ${plan} activé avec succès !`,
      purchaseError: (message) => `Une erreur est survenue : ${message}`,
      testModeTitle: 'Mode test abonnement',
      testModeDesc: 'Changez de plan sans paiement pour vérifier les limites Starter, Basic et Premium.',
      testModeSuccess: (plan) => `Mode test : ${plan} activé.`,
      starterFeatures: ['Profil entreprise', '5 swipes par jour', '5 messages/jour · 100 caractères/message', 'Réception des messages illimitée', 'Visible sur la carte'],
      starterLimits: ['Adresse complète masquée', 'Téléphone, site web et LinkedIn masqués', '1 photo par besoin · 10 MB max'],
      basicFeatures: ['Swipes illimités', 'Messages illimités · 1000 caractères/message', 'Adresse entreprise visible', 'Réception des messages illimitée', 'Statistiques de base'],
      basicLimits: ['Téléphone, site web et LinkedIn masqués', '5 photos par besoin · 10 MB/photo'],
      premiumFeatures: ['Tout Basic inclus', 'Messages jusqu’à 2000 caractères', 'Coordonnées complètes', 'Site web et LinkedIn visibles', '15 fichiers par besoin (photos/PDF)', 'Visibilité prioritaire'],
      premiumLimits: [],
      chooseBasic: 'Choisir Basic',
      choosePremium: 'Choisir Premium',
    },
    companyProfile: {
      featureBasic: 'Fonctionnalité Basic',
      upgradeDesc: 'Passez en Basic ou Premium pour échanger sans limite et accéder à plus de détails entreprise.',
      profileBasicOnlyTitle: 'Profil détaillé réservé aux abonnés',
      profileBasicOnlyDesc: 'Passez à Basic ou Premium pour consulter le profil complet, l’adresse, les besoins et les informations utiles de cette entreprise.',
      profileBasicOnlyCta: 'Voir les plans →',
      inactive: '⚠️ Entreprise inactive',
      reviews: (count) => `(${count} avis)`,
      collaborations: 'Collaborations réussies',
      about: 'À PROPOS',
      needs: 'BESOINS',
      upgradeForNeeds: <>Starter inclut <strong>5 messages envoyés par jour</strong></>,
      answerNeed: 'Répondre à ce besoin →',
      decisionMaker: 'DÉCIDEUR',
      photoLinkedInPremium: 'Photo et LinkedIn disponibles en Premium',
      availableBasic: <>Disponible dès le plan <strong>Basic</strong></>,
      information: 'INFORMATIONS',
      ide: 'IDE',
      city: 'Ville',
      address: 'Adresse',
      website: 'Site web',
      addressBasic: 'Adresse complète disponible dès Basic',
      websitePremium: 'Site web disponible en Premium',
      fullContactPremium: 'Coordonnées directes disponibles en Premium',
      connecting: 'Connexion...',
      contact: (name) => `🤝 Matcher / contacter ${name}`,
      basicMessaging: 'Starter : 5 messages envoyés par jour · Basic : messages illimités',
      shareProfile: 'Partager ce profil',
      reportProfile: '🚩 Signaler ce profil',
      reportTitle: 'Signaler ce profil',
      reportReason: 'Motif du signalement *',
      reportDetails: 'Détails supplémentaires (optionnel)...',
      reportNote: 'Notre équipe examinera ce signalement dans les 48h. Tout faux signalement peut entraîner une suspension de votre compte.',
      sendReport: 'Envoyer le signalement',
      reportSent: '✅ Signalement envoyé. Notre équipe va examiner ce profil dans les 48h.',
      reportError: 'Impossible d’envoyer le signalement. Vos informations ont été conservées. Réessayez.',
      reportAuthError: 'Impossible de vérifier votre connexion. Reconnectez-vous puis réessayez.',
      reportCompanyMissing: 'Vous devez disposer d’un profil d’entreprise pour envoyer un signalement.',
      reasons: [
        { value: 'fake_profile', label: "🚫 Faux profil / usurpation d'identité" },
        { value: 'abusive_behavior', label: '⚠️ Comportement abusif ou harcelant' },
        { value: 'inappropriate_message', label: '🔞 Message inapproprié ou sexuel' },
        { value: 'spam', label: '📧 Spam ou contenu commercial abusif' },
        { value: 'other', label: '❓ Autre' },
      ],
    },
    profile: {
      editTitle: 'Modifier le profil',
      company: 'ENTREPRISE',
      companyName: "Nom de l'entreprise *",
      sector: "Secteur d'activité",
      city: 'Ville',
      address: 'Adresse complète *',
      description: "Description de l'entreprise...",
      serviceTags: {
        title: 'SERVICES PROPOSÉS',
        help: 'Ajoutez jusqu’à 10 services. Ils servent à vous proposer les besoins les plus pertinents.',
        placeholder: 'Peinture, Jardinage, Comptabilité...',
        add: 'Ajouter',
        limit: 'Maximum 10 services',
      },
      website: 'Site web (https://...)',
      contact: 'DÉCIDEUR / CONTACT PRINCIPAL',
      contactName: 'Nom et prénom *',
      contactTitle: 'Titre (CEO, Directeur, Gérant...)',
      contactPhone: 'Téléphone direct *',
      phoneRequired: 'Le téléphone direct du décideur est obligatoire.',
      descriptionContactBlocked: 'Les numéros de téléphone, emails, liens LinkedIn et sites web ne peuvent pas être ajoutés dans la description. Veuillez utiliser les champs prévus pour ces informations afin de respecter la visibilité liée aux abonnements.',
      contactLinkedin: 'LinkedIn (https://linkedin.com/in/...)',
      contactPhoto: 'Photo du décisionnaire :',
      choosePhoto: 'Choisir une photo',
      needs: 'RECHERCHE PERMANENTE',
      needsHelp: "Décrivez les partenaires ou collaborations que vous recherchez toute l’année. Aucune date nécessaire.",
      punctualNeeds: 'BESOINS PONCTUELS',
      punctualNeedsHelp: "Publiez une demande précise avec une date de début et une échéance.",
      startDate: 'Date de début',
      endDate: 'Échéance',
      datesRequired: 'Choisissez une date de début et une échéance.',
      noDeadline: 'Sans échéance',
      tagPlaceholder: 'Ex: Ingénieur civil, Électricien, Comptable...',
      add: '+ Ajouter',
      expiryOptional: "La date d'échéance est optionnelle",
      notifications: 'NOTIFICATIONS',
      appNotif: "🔔 Notifications dans l'app",
      appNotifDesc: 'Nouveaux matchs, messages, alertes',
      emailNotif: '📧 Notifications par email',
      emailNotifDesc: 'Résumé des activités par email',
      security: 'SÉCURITÉ',
      passwordHelp: 'Modifiez le mot de passe du compte Hubbing. Un email de sécurité sera envoyé à l’adresse du compte après le changement.',
      newPassword: 'Nouveau mot de passe',
      confirmPassword: 'Confirmer le nouveau mot de passe',
      changePassword: 'Modifier le mot de passe',
      passwordChanging: 'Modification...',
      passwordMinLength: 'Le mot de passe doit contenir au moins 8 caractères.',
      passwordMismatch: 'Les deux mots de passe ne correspondent pas.',
      passwordUpdated: 'Mot de passe modifié. Un email de sécurité vient d’être envoyé.',
      passwordUpdatedEmailFailed: 'Mot de passe modifié, mais l’email de sécurité n’a pas pu être envoyé.',
      passwordUpdateError: (message) => `Impossible de modifier le mot de passe : ${message}`,
      updated: '✓ Profil mis à jour !',
      background: 'Fond',
      downloading: 'Téléchargement...',
      matches: 'Matchs',
      messages: 'Messages',
      collaborations: 'Collaborations',
      myPlan: 'Mon plan →',
      about: 'À PROPOS',
      companyInfo: 'INFORMATIONS ENTREPRISE',
      zefix: 'Numéro IDE',
      verificationStatus: 'Vérification',
      verificationVerified: 'Validée automatiquement via Zefix',
      verificationManualApproved: 'Validée par Hubbing',
      verificationPending: 'En cours de vérification',
      verificationRejected: 'Vérification refusée',
      email: 'Email',
      editProfile: 'Modifier mon profil',
      previewCard: 'Voir mon profil comme les autres',
      previewTitle: 'Votre carte vue par les autres',
      previewHelp: 'Aperçu de votre carte dans Swipe.',
      previewBadge: 'APERÇU',
      shareProfile: 'Partager le profil',
      shareProfileBusy: 'Préparation du visuel...',
      shareProfileError: 'Impossible de partager ce profil pour le moment.',
      shareText: (name) => `Découvrez ${name} sur Hubbing.\nOuvrir Hubbing : https://app.hubbing.ch\nApp Store : https://apps.apple.com/ch/app/hubbing/id6762903411`,
      shareCardTagline: 'Le réseau B2B suisse',
      shareCardCta: '',
      contactHubbing: '✉️ Contacter Hubbing',
      deleteAccount: 'Supprimer mon compte',
      warningTitle: '⚠️ Attention',
      warningText: 'Vous êtes sur le point de supprimer votre compte Hubbing. Cette action supprimera définitivement votre profil, vos matchs et vos messages. Vous pourrez vous réinscrire plus tard avec le même email.',
      appleSubscriptionNotice: 'Important : Hubbing ne peut pas annuler automatiquement un abonnement App Store. Si vous avez un abonnement Apple actif, annulez-le dans la gestion des abonnements Apple avant ou après la suppression.',
      manageAppleSubscription: 'Gérer mon abonnement Apple',
      abandon: 'Abandonner',
      continue: 'Poursuivre',
      finalConfirm: '🔴 Confirmation finale',
      finalConfirmText: (email) => <>Votre compte sera supprimé définitivement et l’email <strong>{email}</strong> pourra être réutilisé pour une future inscription.</>,
      confirm: 'Confirmer',
      requestSent: '✅ Compte supprimé',
      requestSentText: (email) => `Le compte lié à ${email} a été supprimé. Vous allez être déconnecté.`,
      unknown: 'Inconnu',
      deleteError: 'Une erreur est survenue.',
      uploadError: 'Erreur lors du téléchargement.',
      imageTypeError: 'Veuillez choisir une image valide.',
      imageSizeError: 'Image trop lourde. Taille maximum : 10 MB.',
      imageBlocked: '⚠️ Image refusée\n\nCette image ne respecte pas les règles de Hubbing. Les paysages, logos, bâtiments et photos professionnelles sont autorisés.',
      expired: '⚠️ Expiré',
      expiresToday: "⏰ Expire aujourd'hui",
      daysLeft: (days) => `⏰ ${days}j restants`,
      until: (date) => `✓ jusqu'au ${date}`,
    },
    needAttachments: {
      attachmentsTitle: 'Pièces jointes du besoin',
      cloudTitle: 'Cloud Hubbing privé',
      cloudDescription: () => 'Votre espace privé : retrouvez tous vos fichiers attachés aux besoins. Personne d’autre ne peut consulter ce cloud.',
      emptyCloud: 'Aucun fichier ajouté pour le moment.',
      openCloud: 'Ouvrir le cloud',
      cloudHint: 'Galerie privée de vos pièces jointes',
      allFiles: 'Tous les fichiers',
      close: 'Fermer',
      previewUnavailable: 'Aperçu indisponible',
      fileCount: (count) => `${count} fichier${count > 1 ? 's' : ''}`,
      policyLine: (plan) => plan === 'Premium'
        ? 'Premium : jusqu’à 15 fichiers par besoin, photos ou PDF. Photos 10 MB, PDF 50 MB.'
        : plan === 'Basic'
          ? 'Basic : jusqu’à 5 photos par besoin, 10 MB par photo.'
          : 'Starter : 1 photo par besoin, 10 MB max.',
      takePhoto: 'Prendre une photo',
      importFile: 'Importer',
      uploading: 'Envoi...',
      open: 'Ouvrir',
      report: 'Signaler',
      delete: 'Supprimer',
      deleting: 'Suppression...',
      confirmDelete: 'Supprimer cette pièce jointe ?',
      deleteError: 'Suppression impossible.',
      uploadError: "Erreur lors de l'envoi du fichier.",
      limitReached: (max) => `Limite atteinte : ${max} fichier(s) par besoin.`,
      invalidType: 'Type de fichier non autorisé.',
      pdfPremiumOnly: 'Les PDF sont réservés au plan Premium.',
      imageTooLarge: 'Image trop lourde. Taille maximum : 10 MB.',
      pdfTooLarge: 'PDF trop lourd. Taille maximum : 50 MB.',
      moderationBlocked: 'Cette image ne respecte pas les règles de Hubbing.',
      reportTitle: 'Signaler une pièce jointe',
      reportReason: 'Motif du signalement *',
      reportDetails: 'Détails supplémentaires (optionnel)...',
      reportNote: 'Hubbing recevra le signalement avec les informations du fichier et un lien sécurisé temporaire.',
      sendReport: 'Envoyer le signalement',
      reportSent: 'Signalement envoyé. Hubbing va examiner le fichier.',
      reportError: 'Signalement impossible.',
      reportReasons: [
        { value: 'sexual', label: 'Contenu sexuel ou indécent' },
        { value: 'racist', label: 'Contenu raciste ou discriminatoire' },
        { value: 'violent', label: 'Contenu violent ou illégal' },
        { value: 'spam', label: 'Spam ou abus' },
        { value: 'other', label: 'Autre' },
      ],
    },
    needDetails: {
      title: 'Détails du besoin',
      publishedOn: 'Publié le',
      startsOn: 'Date de début',
      endsOn: 'Échéance',
      photos: 'PHOTOS ET DOCUMENTS',
      noPhotos: 'Aucune photo jointe à ce besoin.',
      loadingPhotos: 'Chargement des photos...',
      contact: 'Contacter par message',
      contacting: 'Ouverture...',
      ownNeed: 'Ceci est votre propre besoin.',
      information: 'Informations sur le besoin',
      permanent: 'Recherche permanente',
      punctual: 'Besoin ponctuel',
      noDeadline: 'Sans échéance',
    },
    privacy: {
      title: 'Politique de confidentialité',
      updated: 'Dernière mise à jour : 22 avril 2026',
      introTitle: '1. Introduction',
      intro: "Hubbing attache une grande importance à la protection de vos données personnelles. Cette politique décrit comment nous collectons, utilisons et protégeons vos données dans l'application Hubbing.",
      controllerTitle: '2. Responsable du traitement',
      controller: 'Hubbing — Suisse',
      contact: 'Contact : contact@hubbing.ch',
      dataTitle: '3. Données collectées',
      data: ['Informations de profil entreprise', 'Coordonnées et adresse email', 'Données de connexion', "Données d'utilisation : swipes, matchs et messages", "Données de paiement liées à votre abonnement"],
      useTitle: '4. Finalités du traitement',
      use: ['Créer et gérer votre compte entreprise', 'Afficher votre profil aux autres membres', 'Permettre le matching et la messagerie B2B', 'Traiter les paiements', 'Améliorer nos services'],
      rightsTitle: '5. Vos droits',
      rights: "Vous pouvez demander l'accès, la rectification ou la suppression de vos données en écrivant à contact@hubbing.ch.",
    },
  },
}

dictionaries.de = {
  common: {
    loading: 'Wird geladen...',
    openingAttachment: 'Datei wird geöffnet…',
    attachmentOpenError: 'Die Datei konnte nicht geöffnet werden. Prüfen Sie Ihre Verbindung und tippen Sie erneut auf die Datei.',
    attachmentNoViewer: 'Keine App kann dieses Format öffnen. Installieren Sie eine geeignete App und versuchen Sie es erneut.',
    cancel: 'Abbrechen',
    back: '← Zurück',
    close: 'Schliessen',
    save: 'Speichern',
    saving: 'Speichern...',
    sending: 'Senden...',
    upload: 'Upload...',
    upgrade: 'Upgrade →',
    viewPlans: 'Tarife ansehen →',
    viewProfile: 'Profil ansehen →',
    companyNotFound: 'Profil nicht gefunden',
    free: 'Gratis',
    month: '/Monat',
    currentPlan: 'Aktueller Plan',
  },
  nav: {
    home: 'Start',
    swipe: 'Swipe',
    newCompanies: count => `${count} ${count === 1 ? 'neues Unternehmen' : 'neue Unternehmen'}`,
    map: 'Karte',
    messages: 'Nachrichten',
    profile: 'Profil',
    pricing: 'Preise',
  },
  usageGuide: {
    usageGuide: 'Anleitung',
    usageGuideTitle: 'So nutzen Sie Hubbing',
    usageGuideIntro: 'Eine kurze Übersicht über die Menüs und wichtigsten Funktionen.',
    usageGuideBack: 'Zurück',
    usageGuideClose: 'Anleitung schliessen',
    usageGuideSteps: [
      { title: 'Start', body: 'Sehen Sie Ihre Übersicht, Ihr Profil und die nächsten wichtigen Schritte.' },
      { title: 'Swipe', body: 'Entdecken Sie Unternehmen, filtern Sie nach Branche, Kanton, Radius oder Bedarf und matchen Sie passende Partner.' },
      { title: 'Karte', body: 'Sehen Sie Schweizer Unternehmen in Ihrer Nähe und öffnen Sie deren Profil direkt auf der Karte.' },
      { title: 'Nachrichten', body: 'Schreiben Sie Ihren Kontakten, sehen Sie gelesene Nachrichten und behalten Sie Gespräche im Blick.' },
      { title: 'Profil', body: 'Aktualisieren Sie Ihre Daten, B2B-Bedürfnisse, Bilder und Einstellungen.' },
      { title: 'Preise', body: 'Vergleichen Sie Starter, Basic und Premium, um die passende Sichtbarkeit zu wählen.' },
    ],
  },
  home: {
    morning: 'Guten Morgen',
    afternoon: 'Guten Nachmittag',
    evening: 'Guten Abend',
    companiesOnHubbing: (count) => `${count} Unternehmen auf Hubbing`,
    followingLabel: 'Ich folge',
    followersLabel: 'Folgen mir',
    collaborationsLabel: 'Erfolgreich',
    followersTitle: 'Unternehmen, die mir folgen',
    followingTitle: 'Unternehmen, denen ich folge',
    noFollowers: 'Noch folgt Ihnen niemand',
    noFollowing: 'Sie folgen noch keinem Unternehmen',
    viewAll: 'Alle ansehen →',
    noConnections: 'Noch keine Verbindungen',
    discoverCompanies: 'Unternehmen entdecken',
    completeProfile: 'Profil vervollständigen',
    completeProfileDesc: 'Ein vollständiges Profil erhält 3x mehr Matches',
    discoverTitle: 'Unternehmen entdecken',
    discoverDesc: 'Swipen Sie und erstellen Sie B2B-Verbindungen',
    opportunitiesTitle: 'Ihre aktuellen B2B-Chancen',
    opportunitiesAllowance: (limit, plan) => limit ? `${limit} sichtbare Chancen / Woche · ${plan}` : `Unbegrenzte Chancen · ${plan}`,
    opportunitiesFilter: 'Filtern',
    opportunitiesFilterTitle: 'Chancen filtern',
    opportunitiesFilterCount: (count) => `${count} Chance${count > 1 ? 'n' : ''} gefunden`,
    opportunitiesKeyword: 'Stichwort',
    opportunitiesKeywordPlaceholder: 'z.B. Beschriftung, Buchhaltung, Renovation...',
    opportunitiesRadius: (radius) => `Radius: ${radius >= 300 ? 'Ganze Schweiz' : `${radius} km`}`,
    opportunitiesSector: 'Branche',
    opportunitiesAllSectors: 'Alle Branchen',
    opportunitiesCanton: 'Kanton',
    opportunitiesAllCantons: 'Alle Kantone',
    opportunitiesReset: 'Zurücksetzen',
    opportunitiesShowResults: (count) => `${count} Ergebnis${count > 1 ? 'se' : ''} anzeigen`,
    opportunitiesEmpty: 'Derzeit nichts zu zeigen',
    opportunitiesEmptyDesc: 'Bleiben Sie dran: passende Bedürfnisse erscheinen hier, sobald ein Unternehmen eine Chance veröffentlicht.',
    opportunitiesUpgradeHint: (count) => `${count} weitere Chance${count > 1 ? 'n' : ''} mit einem höheren Plan →`,
    opportunityNeed: 'Bedarf',
    opportunityDistance: (km) => `${km} km`,
    opportunityAttachments: (count) => `${count} Datei${count > 1 ? 'en' : ''}`,
  },
  map: {
    createAccount: 'Konto erstellen →',
    login: 'Anmelden →',
    searchPlaceholder: 'Unternehmen, Branche, Stadt suchen...',
    allCantons: 'Alle Kantone',
    allSectors: (count) => `Alle Branchen (${count} Unternehmen)`,
    viewProfile: 'Profil ansehen →',
    profileShort: 'Profil',
    directions: 'Route',
    closeDetails: 'Karte schließen',
    addressUnavailable: 'Adresse nicht verfügbar',
    straightLineDistance: 'Luftlinie von Ihrem Unternehmen',
    approximateDistance: 'Geschätzte Luftlinie von Ihrem Unternehmen',
    distanceUnavailable: 'Entfernung von Ihrem Unternehmen nicht verfügbar',
    profileBasicOnly: 'Detailprofil ab Basic →',
    createAccountToContact: (name) => `Konto erstellen, um ${name} zu kontaktieren →`,
    registeredCount: (count) => `${count} Unternehmen auf Hubbing registriert`,
    filteredCount: (visible, total) => visible === total ? `${total} Unternehmen auf der Karte` : `${visible} / ${total} Unternehmen auf der Karte`,
    approximatePosition: 'Ungefähre Position',
    standardView: 'Karte',
    satelliteView: 'Satellit',
    radius: (radius) => `Radius: ${radius >= 300 ? 'Ganze Schweiz' : `${radius} km`}`,
    radiusButton: (radius) => radius >= 300 ? 'Schweiz' : `${radius} km`,
    allSwitzerland: 'Ganze Schweiz',
    radiusNeedsLocation: 'Aktivieren Sie Ihren Standort oder speichern Sie Ihr Profil, um nach Radius zu filtern.',
    useMyLocation: 'Meinen Standort nutzen',
    myLocation: 'Mein Standort',
    meLabel: 'ICH',
    locating: 'Ortung...',
    locationDenied: 'Standort abgelehnt. Sie können ihn in den Browser- oder iPhone-Einstellungen aktivieren.',
    locationUnavailable: 'Standort momentan nicht verfügbar.',
  },
  swipe: {
    noResults: 'Keine Ergebnisse für diese Filter',
    allSeen: 'Sie haben alles gesehen!',
    noResultsDesc: 'Erweitern Sie den Radius, ändern Sie die Branche oder suchen Sie nach einem anderen Bedarf.',
    allSeenDesc: 'Sie haben alle verfügbaren Unternehmen durchgesehen.',
    clearFilters: 'Filter löschen',
    reviewAll: 'Von vorne ansehen',
    newOnly: 'Nur neue anzeigen',
    matchSent: 'Match gesendet!',
    matchAlreadyExists: 'Match existiert bereits',
    createAccountTitle: 'Konto erstellen!',
    signupToSave: 'Registrieren Sie sich, um dieses Match zu speichern.',
    createAccount: 'Konto erstellen →',
    login: 'Anmelden →',
    continueVisitor: 'Im Besuchermodus fortfahren',
    filters: 'Filter',
    needsSearch: 'Nach Bedarf suchen',
    needsSearchPlaceholder: 'z.B. Harz, Buchhalter, Website...',
    radius: (radius) => `Radius: ${radius >= 300 ? 'Ganze Schweiz' : `${radius} km`}`,
    allSwitzerland: 'Ganze Schweiz',
    saveProfileRadius: '⚠️ Speichern Sie Ihr Profil, um den Radiusfilter zu aktivieren',
    sector: 'Branche',
    allSectors: 'Alle Branchen',
    canton: 'Kanton',
    allCantons: 'Alle Kantone',
    clear: 'Löschen',
    apply: (count) => `Anwenden (${count} Ergebnisse)`,
    applyNoCount: 'Anwenden',
    discovery: 'Entdecken',
    visitorMode: '👀 Besuchermodus — ',
    visitorCreate: 'Erstellen Sie ein Konto',
    visitorSuffix: ', um Ihre Matches zu speichern',
    filtersButton: '🎛 Filter',
    previousCard: 'Vorherige Karte',
    viewProfile: 'Profil ansehen',
    shareProfile: 'Profil teilen',
    pass: 'Überspringen',
    match: 'Matchen',
    newLabel: 'Neu',
    needs: 'BEDARF',
    pressCheck: 'Tippen Sie auf ✓, um ein Konto zu erstellen',
  },
  messages: {
    title: 'Nachrichten',
    subtitle: 'Ihre B2B-Verbindungen',
    searchPlaceholder: 'Unternehmen suchen...',
    noSearchResults: 'Keine Unterhaltung gefunden',
    searchHint: 'Versuchen Sie es mit Name, Branche, Stadt oder einem Wort aus der letzten Nachricht.',
    noConnections: 'Noch keine Verbindungen',
    noConnectionsDesc: 'Swipen Sie Unternehmen, um Gespräche zu starten!',
    reviewTitle: (name) => `${name} bewerten`,
    ratingLabel: 'Gesamtbewertung *',
    commentOptional: 'Kommentar (optional)',
    commentPlaceholder: 'Beschreiben Sie Ihre Erfahrung mit diesem Unternehmen...',
    moderation: '⚠️ Ihre Bewertung wird vor der Veröffentlichung moderiert. Missbrauch kann zur Sperrung führen.',
    editReview: 'Bewertung ändern',
    submitReview: 'Bewertung senden',
    evaluate: 'Bewerten',
    startConversation: (name) => `Beginn der Unterhaltung mit ${name}`,
    introduce: 'Stellen Sie sich vor!',
    messagePlaceholder: 'Ihre Nachricht...',
    sent: 'Gesendet',
    read: 'Gelesen',
    attachment: 'Anhang',
    youPrefix: 'Sie:',
    today: 'Heute',
    yesterday: 'Gestern',
    needDraft: (subject) => `Bedarf: ${subject}\n\n`,
    needSubjectLabel: (subject) => `Bedarfsthema: ${subject}`,
    basicOnly: 'Messaging ist ab Basic verfügbar',
    upgradeBasic: 'Zum Basic-Plan wechseln →',
    deleteConversation: 'Unterhaltung löschen',
    deleteConversationAction: 'Löschen',
    deleteConversationConfirm: (name) => `Unterhaltung mit ${name} löschen?`,
    deleteConversationError: 'Die Unterhaltung kann im Moment nicht gelöscht werden.',
    viewProfile: 'Profil ansehen →',
    viewProfileShort: 'Profil',
    profileBasicOnly: 'Basic',
    deleteForAllConfirm: 'Diese Nachricht für alle löschen?',
    deleteForMeConfirm: 'Diese Nachricht nur für Sie löschen?',
    fileTypeError: 'Dateityp nicht erlaubt.\n\nAkzeptierte Formate: Bilder, PDF, Word, Excel, PowerPoint.',
    fileSizeError: 'Datei zu gross. Maximale Grösse: 10 MB.',
    fileUploadError: 'Fehler beim Senden der Datei.',
    fileBlocked: '⚠️ Datei blockiert\n\nDieses Bild entspricht nicht den Hubbing-Regeln. Bitte wählen Sie ein professionelles Bild.',
    reviewBlocked: '⚠️ Bewertung nicht gesendet\n\nIhr Kommentar enthält unangemessene Inhalte.',
    messageBlocked: '⚠️ Nachricht nicht gesendet\n\nIhre Nachricht enthält unangemessene Inhalte.',
    directContactBlocked: '⚠️ Kontaktdaten blockiert\n\nTelefonnummern, E-Mails und externe Links dürfen in Hubbing-Nachrichten nicht ausgetauscht werden. Führen Sie das Gespräch direkt in der App weiter.',
    starterDailyLimit: (remaining, max) => remaining > 0
      ? `Starter: ${remaining}/${max} Nachrichten heute übrig`
      : 'Starter: Tageslimit erreicht',
    starterLimitReached: 'Tageslimit erreicht.\n\nSie haben heute Ihre 5 kostenlosen Nachrichten gesendet. Wechseln Sie zu Basic oder Premium, um unbegrenzt zu schreiben.',
    starterLimitPlaceholder: 'Tageslimit erreicht',
    messageTooLong: (limit) => `Nachricht zu lang.\n\nDieser Plan erlaubt maximal ${limit} Zeichen pro Nachricht.`,
  },
  pricing: {
    title: 'Wählen Sie Ihren Plan',
    subtitle: 'Entwickeln Sie Ihr B2B-Netzwerk in der Schweiz',
    recommended: 'EMPFOHLEN',
    recommendedPlain: 'EMPFOHLEN',
    footer: 'Jederzeit kündbar · Sichere Zahlung · Nur CHF',
    appleFooter: 'Jederzeit kündbar · Zahlung über den App Store · Nur CHF',
    androidFooter: 'Jederzeit kündbar · Zahlung über Google Play · Nur CHF',
    legalLinksTitle: 'Rechtliche Informationen zu Abonnements',
    termsOfUseEula: 'Nutzungsbedingungen (EULA)',
    privacyPolicyLink: 'Datenschutzrichtlinie',
    restorePurchases: 'Käufe wiederherstellen',
    purchasePending: 'Ihr Kauf wartet auf die Bestätigung.',
    purchaseRestored: 'Käufe erfolgreich wiederhergestellt.',
    noPurchaseToRestore: 'Kein aktives Abonnement gefunden.',
    appleProductsUnavailable: 'Apple-Abonnements sind noch nicht verfügbar. Prüfen Sie die Produkte in App Store Connect.',
    androidBillingUnavailable: 'Google Play-Abonnements sind noch nicht verfügbar. Prüfen Sie die Produkte in der Play Console.',
    androidVerificationFailed: 'Google Play konnte dieses Abonnement nicht bestätigen. Versuchen Sie es erneut oder stellen Sie Ihre Käufe wieder her.',
    downgradeScheduled: 'Ihr Wechsel zu Basic ist für den nächsten Abrechnungstermin geplant.',
    purchaseSuccess: (plan) => `Abonnement ${plan} erfolgreich aktiviert!`,
    purchaseError: (message) => `Ein Fehler ist aufgetreten: ${message}`,
    testModeTitle: 'Abo-Testmodus',
    testModeDesc: 'Wechseln Sie ohne Zahlung zwischen Starter, Basic und Premium, um die Limits zu prüfen.',
    testModeSuccess: (plan) => `Testmodus: ${plan} aktiviert.`,
    starterFeatures: ['Unternehmensprofil', '5 Swipes pro Tag', '5 Nachrichten/Tag · 100 Zeichen/Nachricht', 'Nachrichten unbegrenzt empfangen', 'Auf der Karte sichtbar'],
    starterLimits: ['Vollständige Adresse ausgeblendet', 'Telefon, Website und LinkedIn ausgeblendet', 'Keine Anhänge'],
    basicFeatures: ['Unbegrenzte Swipes', 'Unbegrenzte Nachrichten · 1000 Zeichen/Nachricht', 'Firmenadresse sichtbar', 'Nachrichten unbegrenzt empfangen', 'Basisstatistiken'],
    basicLimits: ['Telefon, Website und LinkedIn ausgeblendet', 'Keine Anhänge'],
    premiumFeatures: ['Alles aus Basic', 'Nachrichten bis 2000 Zeichen', 'Vollständige Kontaktdaten', 'Website und LinkedIn sichtbar', 'Anhänge in Nachrichten', 'Priorisierte Sichtbarkeit'],
    premiumLimits: [],
    chooseBasic: 'Basic wählen',
    choosePremium: 'Premium wählen',
  },
}

dictionaries.it = {
  common: {
    loading: 'Caricamento...',
    openingAttachment: 'Apertura del file…',
    attachmentOpenError: 'Impossibile aprire il file. Controlla la connessione e tocca il file per riprovare.',
    attachmentNoViewer: 'Nessuna app può aprire questo formato. Installa un lettore compatibile e riprova.',
    cancel: 'Annulla',
    back: '← Indietro',
    close: 'Chiudi',
    save: 'Salva',
    saving: 'Salvataggio...',
    sending: 'Invio...',
    upload: 'Upload...',
    upgrade: 'Upgrade →',
    viewPlans: 'Vedi i piani →',
    viewProfile: 'Vedi profilo →',
    companyNotFound: 'Profilo non trovato',
    free: 'Gratis',
    month: '/mese',
    currentPlan: 'Piano attuale',
  },
  nav: {
    home: 'Home',
    swipe: 'Swipe',
    newCompanies: count => `${count} ${count === 1 ? 'nuova azienda' : 'nuove aziende'}`,
    map: 'Mappa',
    messages: 'Messaggi',
    profile: 'Profilo',
    pricing: 'Tariffe',
  },
  usageGuide: {
    usageGuide: "Guida all'uso",
    usageGuideTitle: 'Come usare Hubbing',
    usageGuideIntro: 'Una panoramica rapida dei menu e delle funzioni principali.',
    usageGuideBack: 'Indietro',
    usageGuideClose: 'Chiudi la guida',
    usageGuideSteps: [
      { title: 'Home', body: 'Trova il riepilogo, il profilo e le prossime azioni importanti.' },
      { title: 'Swipe', body: 'Scopri aziende, filtra per settore, cantone, raggio o bisogno e crea match con i partner giusti.' },
      { title: 'Mappa', body: 'Visualizza le aziende svizzere vicino a te e apri il loro profilo dalla mappa.' },
      { title: 'Messaggi', body: 'Comunica con le tue connessioni, segui i messaggi letti e mantieni organizzate le conversazioni.' },
      { title: 'Profilo', body: 'Aggiorna informazioni, bisogni B2B, immagini e preferenze.' },
      { title: 'Tariffe', body: 'Confronta Starter, Basic e Premium per scegliere la visibilità più adatta.' },
    ],
  },
}

dictionaries.en = {
  common: {
    loading: 'Loading...',
    openingAttachment: 'Opening file…',
    attachmentOpenError: 'Unable to open the file. Check your connection and tap the file to try again.',
    attachmentNoViewer: 'No app can open this format. Install a compatible viewer and try again.',
    cancel: 'Cancel',
    back: '← Back',
    close: 'Close',
    save: 'Save',
    saving: 'Saving...',
    sending: 'Sending...',
    upload: 'Upload...',
    upgrade: 'Upgrade →',
    viewPlans: 'See plans →',
    viewProfile: 'View profile →',
    companyNotFound: 'Profile not found',
    free: 'Free',
    month: '/month',
    currentPlan: 'Current plan',
  },
  nav: {
    home: 'Home',
    swipe: 'Swipe',
    newCompanies: count => `${count} new ${count === 1 ? 'company' : 'companies'}`,
    map: 'Map',
    messages: 'Messages',
    profile: 'Profile',
    pricing: 'Pricing',
  },
  usageGuide: {
    usageGuide: 'User guide',
    usageGuideTitle: 'How to use Hubbing',
    usageGuideIntro: 'A quick overview of the menus and main features.',
    usageGuideBack: 'Back',
    usageGuideClose: 'Close guide',
    usageGuideSteps: [
      { title: 'Home', body: 'Find your summary, profile and next important actions.' },
      { title: 'Swipe', body: 'Browse companies, filter by sector, canton, radius or need, then match with the right partners.' },
      { title: 'Map', body: 'See Swiss companies around you and open their profile from the map.' },
      { title: 'Messages', body: 'Chat with your connections, track read messages and keep conversations organized.' },
      { title: 'Profile', body: 'Update your information, B2B needs, visuals and preferences.' },
      { title: 'Pricing', body: 'Compare Starter, Basic and Premium to choose the right visibility level.' },
    ],
  },
}

Object.assign(dictionaries.de, {
  needDetails: {
    title: 'Details zum Bedarf',
    publishedOn: 'Veröffentlicht am',
    startsOn: 'Startdatum',
    endsOn: 'Frist',
    photos: 'FOTOS UND DOKUMENTE',
    noPhotos: 'Keine Fotos zu diesem Bedarf.',
    loadingPhotos: 'Fotos werden geladen...',
    contact: 'Per Nachricht kontaktieren',
    contacting: 'Wird geöffnet...',
    ownNeed: 'Dies ist Ihr eigener Bedarf.',
    information: 'Informationen zum Bedarf',
    permanent: 'Dauerhafte Suche',
    punctual: 'Aktueller Bedarf',
    noDeadline: 'Ohne Frist',
  },
  companyProfile: {
    featureBasic: 'Basic-Funktion',
    upgradeDesc: 'Wechseln Sie zu Basic oder Premium, um unbegrenzt zu schreiben und mehr Unternehmensdetails zu sehen.',
    profileBasicOnlyTitle: 'Detailprofil für Abonnenten',
    profileBasicOnlyDesc: 'Wechseln Sie zu Basic oder Premium, um das vollständige Profil, die Adresse, den Bedarf und nützliche Unternehmensinformationen zu sehen.',
    profileBasicOnlyCta: 'Tarife ansehen →',
    inactive: '⚠️ Unternehmen inaktiv',
    reviews: (count) => `(${count} Bewertungen)`,
    collaborations: 'Erfolgreiche Zusammenarbeiten',
    about: 'ÜBER UNS',
    needs: 'BEDARF',
    upgradeForNeeds: <>Starter enthält <strong>5 gesendete Nachrichten pro Tag</strong></>,
    answerNeed: 'Auf diesen Bedarf antworten →',
    decisionMaker: 'ENTSCHEIDUNGSTRÄGER',
    photoLinkedInPremium: 'Foto und LinkedIn sind mit Premium verfügbar',
    availableBasic: <>Verfügbar ab <strong>Basic</strong></>,
    information: 'INFORMATIONEN',
    ide: 'UID',
    city: 'Stadt',
    address: 'Adresse',
    website: 'Website',
    addressBasic: 'Vollständige Adresse ab Basic verfügbar',
    websitePremium: 'Website mit Premium verfügbar',
    fullContactPremium: 'Direkte Kontaktdaten mit Premium verfügbar',
    connecting: 'Verbindung...',
    contact: (name) => `🤝 ${name} matchen / kontaktieren`,
    basicMessaging: 'Starter: 5 gesendete Nachrichten pro Tag · Basic: unbegrenzt',
    reportProfile: '🚩 Profil melden',
    reportTitle: 'Profil melden',
    reportReason: 'Grund der Meldung *',
    reportDetails: 'Zusätzliche Details (optional)...',
    reportNote: 'Unser Team prüft diese Meldung innerhalb von 48 Stunden. Falsche Meldungen können zur Sperrung führen.',
    sendReport: 'Meldung senden',
    reportSent: '✅ Meldung gesendet. Unser Team prüft dieses Profil innerhalb von 48 Stunden.',
    reportError: 'Die Meldung konnte nicht gesendet werden. Ihre Eingaben bleiben erhalten. Bitte versuchen Sie es erneut.',
    reportAuthError: 'Ihre Anmeldung konnte nicht überprüft werden. Melden Sie sich erneut an und versuchen Sie es noch einmal.',
    reportCompanyMissing: 'Sie benötigen ein Unternehmensprofil, um eine Meldung zu senden.',
    reasons: [
      { value: 'fake_profile', label: '🚫 Falsches Profil / Identitätsmissbrauch' },
      { value: 'abusive_behavior', label: '⚠️ Missbräuchliches oder belästigendes Verhalten' },
      { value: 'inappropriate_message', label: '🔞 Unangemessene oder sexuelle Nachricht' },
      { value: 'spam', label: '📧 Spam oder missbräuchliche Werbung' },
      { value: 'other', label: '❓ Andere' },
    ],
  },
  profile: {
    editTitle: 'Profil bearbeiten',
    company: 'UNTERNEHMEN',
    companyName: 'Unternehmensname *',
    sector: 'Branche',
    city: 'Stadt',
    address: 'Vollständige Adresse *',
    description: 'Unternehmensbeschreibung...',
    serviceTags: {
      title: 'ANGEBOTENE LEISTUNGEN',
      help: 'Fügen Sie bis zu 10 Leistungen hinzu, um passende Anfragen zu erhalten.',
      placeholder: 'Malerei, Gartenbau, Buchhaltung...',
      add: 'Hinzufügen',
      limit: 'Maximal 10 Leistungen',
    },
    website: 'Website (https://...)',
    contact: 'ENTSCHEIDUNGSTRÄGER / HAUPTKONTAKT',
    contactName: 'Vor- und Nachname *',
    contactTitle: 'Titel (CEO, Direktor, Geschäftsführer...)',
    contactPhone: 'Direkte Telefonnummer *',
    phoneRequired: 'Die direkte Telefonnummer ist erforderlich.',
    descriptionContactBlocked: 'Telefonnummern, E-Mails, LinkedIn-Links und Websites dürfen nicht in der Beschreibung stehen. Bitte nutzen Sie die vorgesehenen Felder, damit die Sichtbarkeit je nach Abo respektiert wird.',
    contactLinkedin: 'LinkedIn (https://linkedin.com/in/...)',
    contactPhoto: 'Foto des Entscheidungsträgers:',
    choosePhoto: 'Foto auswählen',
    needs: 'DAUERHAFTE SUCHE',
    needsHelp: 'Beschreiben Sie Partner oder Kooperationen, die Sie das ganze Jahr über suchen. Kein Datum erforderlich.',
    punctualNeeds: 'AKTUELLER BEDARF',
    punctualNeedsHelp: 'Veröffentlichen Sie eine konkrete Anfrage mit Startdatum und Frist.',
    startDate: 'Startdatum',
    endDate: 'Frist',
    datesRequired: 'Wählen Sie ein Startdatum und eine Frist.',
    noDeadline: 'Ohne Frist',
    tagPlaceholder: 'z.B. Bauingenieur, Elektriker, Buchhalter...',
    add: '+ Hinzufügen',
    expiryOptional: 'Das Fälligkeitsdatum ist optional',
    notifications: 'BENACHRICHTIGUNGEN',
    appNotif: '🔔 App-Benachrichtigungen',
    appNotifDesc: 'Neue Matches, Nachrichten, Hinweise',
    emailNotif: '📧 E-Mail-Benachrichtigungen',
    emailNotifDesc: 'Aktivitätsübersicht per E-Mail',
    security: 'SICHERHEIT',
    passwordHelp: 'Ändern Sie das Passwort des Hubbing-Kontos. Nach der Änderung wird eine Sicherheits-E-Mail an die Konto-Adresse gesendet.',
    newPassword: 'Neues Passwort',
    confirmPassword: 'Neues Passwort bestätigen',
    changePassword: 'Passwort ändern',
    passwordChanging: 'Änderung...',
    passwordMinLength: 'Das Passwort muss mindestens 8 Zeichen enthalten.',
    passwordMismatch: 'Die beiden Passwörter stimmen nicht überein.',
    passwordUpdated: 'Passwort geändert. Eine Sicherheits-E-Mail wurde gesendet.',
    passwordUpdatedEmailFailed: 'Passwort geändert, aber die Sicherheits-E-Mail konnte nicht gesendet werden.',
    passwordUpdateError: (message) => `Passwort konnte nicht geändert werden: ${message}`,
    updated: '✓ Profil aktualisiert!',
    background: 'Hintergrund',
    downloading: 'Hochladen...',
    matches: 'Matches',
    messages: 'Nachrichten',
    collaborations: 'Zusammenarbeiten',
    myPlan: 'Mein Plan →',
    about: 'ÜBER UNS',
    companyInfo: 'UNTERNEHMENSINFORMATIONEN',
    zefix: 'UID-Nummer',
    email: 'E-Mail',
    editProfile: 'Mein Profil bearbeiten',
    previewCard: 'Mein Profil aus fremder Sicht',
    previewTitle: 'Ihre Karte aus Sicht anderer',
    previewHelp: 'Vorschau Ihrer Karte in Swipe.',
    previewBadge: 'VORSCHAU',
    contactHubbing: '✉️ Hubbing kontaktieren',
    deleteAccount: 'Mein Konto löschen',
    warningTitle: '⚠️ Achtung',
    warningText: 'Sie sind dabei, Ihr Hubbing-Konto zu löschen. Diese Aktion löscht Ihr Profil, Ihre Matches und Ihre Nachrichten endgültig. Sie können sich später mit derselben E-Mail erneut registrieren.',
    appleSubscriptionNotice: 'Wichtig: Hubbing kann ein App-Store-Abonnement nicht automatisch kündigen. Wenn Sie ein aktives Apple-Abonnement haben, kündigen Sie es bitte in der Apple-Abonnementverwaltung.',
    manageAppleSubscription: 'Apple-Abonnement verwalten',
    abandon: 'Abbrechen',
    continue: 'Fortfahren',
    finalConfirm: '🔴 Letzte Bestätigung',
    finalConfirmText: (email) => <>Ihr Konto wird endgültig gelöscht und die E-Mail <strong>{email}</strong> kann für eine spätere Registrierung wieder verwendet werden.</>,
    confirm: 'Bestätigen',
    requestSent: '✅ Konto gelöscht',
    requestSentText: (email) => `Das Konto mit ${email} wurde gelöscht. Sie werden nun abgemeldet.`,
    unknown: 'Unbekannt',
    deleteError: 'Ein Fehler ist aufgetreten.',
    uploadError: 'Fehler beim Hochladen.',
    imageTypeError: 'Bitte wählen Sie ein gültiges Bild.',
    imageSizeError: 'Bild zu gross. Maximale Grösse: 10 MB.',
    imageBlocked: '⚠️ Bild abgelehnt\n\nDieses Bild entspricht nicht den Hubbing-Regeln. Landschaften, Logos, Gebäude und professionelle Fotos sind erlaubt.',
    expired: '⚠️ Abgelaufen',
    expiresToday: '⏰ Läuft heute ab',
    daysLeft: (days) => `⏰ ${days} Tage übrig`,
    until: (date) => `✓ bis ${date}`,
  },
  privacy: {
    title: 'Datenschutzrichtlinie',
    updated: 'Letzte Aktualisierung: 22. April 2026',
    introTitle: '1. Einführung',
    intro: 'Hubbing legt grossen Wert auf den Schutz Ihrer personenbezogenen Daten. Diese Richtlinie beschreibt, wie wir Ihre Daten in der Hubbing-App erheben, verwenden und schützen.',
    controllerTitle: '2. Verantwortlicher',
    controller: 'Hubbing — Schweiz',
    contact: 'Kontakt: contact@hubbing.ch',
    dataTitle: '3. Erhobene Daten',
    data: ['Unternehmensprofilinformationen', 'Kontaktdaten und E-Mail-Adresse', 'Verbindungsdaten', 'Nutzungsdaten: Swipes, Matches und Nachrichten', 'Zahlungsdaten zu Ihrem Abonnement'],
    useTitle: '4. Zwecke der Verarbeitung',
    use: ['Ihr Unternehmenskonto erstellen und verwalten', 'Ihr Profil anderen Mitgliedern anzeigen', 'Matching und B2B-Messaging ermöglichen', 'Zahlungen verarbeiten', 'Unsere Dienste verbessern'],
    rightsTitle: '5. Ihre Rechte',
    rights: 'Sie können Auskunft, Berichtigung oder Löschung Ihrer Daten beantragen, indem Sie an contact@hubbing.ch schreiben.',
  },
})

Object.assign(dictionaries.it, {
  needDetails: {
    title: 'Dettagli del bisogno',
    publishedOn: 'Pubblicato il',
    startsOn: 'Data di inizio',
    endsOn: 'Scadenza',
    photos: 'FOTO E DOCUMENTI',
    noPhotos: 'Nessuna foto allegata a questo bisogno.',
    loadingPhotos: 'Caricamento delle foto...',
    contact: 'Contatta tramite messaggio',
    contacting: 'Apertura...',
    ownNeed: 'Questo è il tuo bisogno.',
    information: 'Informazioni sul bisogno',
    permanent: 'Ricerca permanente',
    punctual: 'Bisogno puntuale',
    noDeadline: 'Senza scadenza',
  },
  home: {
    morning: 'Buongiorno',
    afternoon: 'Buon pomeriggio',
    evening: 'Buonasera',
    companiesOnHubbing: (count) => `${count} aziende su Hubbing`,
    followingLabel: 'Seguo',
    followersLabel: 'Mi seguono',
    collaborationsLabel: 'Collaborazioni',
    followersTitle: 'Aziende che mi seguono',
    followingTitle: 'Aziende che seguo',
    noFollowers: 'Nessuno ti segue ancora',
    noFollowing: 'Non segui ancora nessuna azienda',
    viewAll: 'Vedi tutto →',
    noConnections: 'Ancora nessuna connessione',
    discoverCompanies: 'Scopri aziende',
    completeProfile: 'Completa il tuo profilo',
    completeProfileDesc: 'Un profilo completo attira 3x più match',
    discoverTitle: 'Scopri aziende',
    discoverDesc: 'Scorri e crea connessioni B2B',
    opportunitiesTitle: 'Le tue opportunità B2B del momento',
    opportunitiesAllowance: (limit, plan) => limit ? `${limit} opportunità visibili / settimana · ${plan}` : `Opportunità illimitate · ${plan}`,
    opportunitiesFilter: 'Filtra',
    opportunitiesFilterTitle: 'Filtra opportunità',
    opportunitiesFilterCount: (count) => `${count} opportunità trovata${count > 1 ? 'e' : ''}`,
    opportunitiesKeyword: 'Parola chiave',
    opportunitiesKeywordPlaceholder: 'Es: insegna, contabilità, ristrutturazione...',
    opportunitiesRadius: (radius) => `Raggio: ${radius >= 300 ? 'Tutta la Svizzera' : `${radius} km`}`,
    opportunitiesSector: 'Settore',
    opportunitiesAllSectors: 'Tutti i settori',
    opportunitiesCanton: 'Cantone',
    opportunitiesAllCantons: 'Tutti i cantoni',
    opportunitiesReset: 'Reimposta',
    opportunitiesShowResults: (count) => `Vedi ${count} risultato${count > 1 ? 'i' : ''}`,
    opportunitiesEmpty: 'Niente da mostrare al momento',
    opportunitiesEmptyDesc: "Restate aggiornati: i bisogni compatibili appariranno qui appena un'azienda pubblica un'opportunità.",
    opportunitiesUpgradeHint: (count) => `${count} opportunità in più con un piano superiore →`,
    opportunityNeed: 'Bisogno',
    opportunityDistance: (km) => `${km} km`,
    opportunityAttachments: (count) => `${count} file`,
  },
  map: {
    createAccount: 'Crea un account →',
    login: 'Accedi →',
    searchPlaceholder: 'Cerca azienda, settore, città...',
    allCantons: 'Tutti i cantoni',
    allSectors: (count) => `Tutti i settori (${count} aziende)`,
    viewProfile: 'Vedi profilo →',
    profileShort: 'Profilo',
    directions: 'Indicazioni',
    closeDetails: 'Chiudi la scheda',
    addressUnavailable: 'Indirizzo non disponibile',
    straightLineDistance: 'Distanza in linea d’aria dalla tua azienda',
    approximateDistance: 'Distanza stimata in linea d’aria dalla tua azienda',
    distanceUnavailable: 'Distanza dalla tua azienda non disponibile',
    profileBasicOnly: 'Profilo dettagliato da Basic →',
    createAccountToContact: (name) => `Crea un account per contattare ${name} →`,
    registeredCount: (count) => `${count} aziende registrate su Hubbing`,
    filteredCount: (visible, total) => visible === total ? `${total} aziende sulla mappa` : `${visible} / ${total} aziende sulla mappa`,
    approximatePosition: 'Posizione approssimativa',
    standardView: 'Mappa',
    satelliteView: 'Satellite',
    radius: (radius) => `Raggio: ${radius >= 300 ? 'Tutta la Svizzera' : `${radius} km`}`,
    radiusButton: (radius) => radius >= 300 ? 'Svizzera' : `${radius} km`,
    allSwitzerland: 'Tutta la Svizzera',
    radiusNeedsLocation: 'Attiva la tua posizione o salva il profilo per filtrare per raggio.',
    useMyLocation: 'Usa la mia posizione',
    myLocation: 'La mia posizione',
    meLabel: 'IO',
    locating: 'Localizzazione...',
    locationDenied: 'Localizzazione rifiutata. Puoi attivarla nelle impostazioni del browser o dell’iPhone.',
    locationUnavailable: 'Posizione non disponibile al momento.',
  },
  swipe: {
    noResults: 'Nessun risultato per questi filtri',
    allSeen: 'Hai visto tutto!',
    noResultsDesc: 'Prova ad ampliare il raggio, cambiare settore o cercare un altro bisogno.',
    allSeenDesc: 'Hai visto tutte le aziende disponibili.',
    clearFilters: 'Cancella filtri',
    reviewAll: 'Rivedi tutto dall’inizio',
    newOnly: 'Vedi solo le nuove',
    matchSent: 'Match inviato!',
    matchAlreadyExists: 'Match già esistente',
    createAccountTitle: 'Crea un account!',
    signupToSave: 'Registrati per salvare questo match.',
    createAccount: 'Crea un account →',
    login: 'Accedi →',
    continueVisitor: 'Continua in modalità visitatore',
    filters: 'Filtri',
    needsSearch: 'Ricerca per bisogno',
    needsSearchPlaceholder: 'Es: resina, contabile, sito web...',
    radius: (radius) => `Raggio: ${radius >= 300 ? 'Tutta la Svizzera' : `${radius} km`}`,
    allSwitzerland: 'Tutta la Svizzera',
    saveProfileRadius: '⚠️ Salva il profilo per attivare il filtro per raggio',
    sector: 'Settore',
    allSectors: 'Tutti i settori',
    canton: 'Cantone',
    allCantons: 'Tutti i cantoni',
    clear: 'Cancella',
    apply: (count) => `Applica (${count} risultati)`,
    applyNoCount: 'Applica',
    discovery: 'Scoperta',
    visitorMode: '👀 Modalità visitatore — ',
    visitorCreate: 'Crea un account',
    visitorSuffix: ' per salvare i tuoi match',
    filtersButton: '🎛 Filtri',
    previousCard: 'Scheda precedente',
    viewProfile: 'Vedi profilo',
    shareProfile: 'Condividi profilo',
    pass: 'Passa',
    match: 'Match',
    newLabel: 'Nuovo',
    needs: 'BISOGNI',
    pressCheck: 'Tocca ✓ per creare un account',
  },
  messages: {
    title: 'Messaggi',
    subtitle: 'Le tue connessioni B2B',
    searchPlaceholder: 'Cerca un’azienda...',
    noSearchResults: 'Nessuna conversazione trovata',
    searchHint: 'Prova con nome, settore, città o una parola dell’ultimo messaggio.',
    noConnections: 'Ancora nessuna connessione',
    noConnectionsDesc: 'Scorri le aziende per avviare conversazioni!',
    reviewTitle: (name) => `Valuta ${name}`,
    ratingLabel: 'Valutazione globale *',
    commentOptional: 'Commento (opzionale)',
    commentPlaceholder: 'Descrivi la tua esperienza con questa azienda...',
    moderation: '⚠️ La tua recensione sarà moderata prima della pubblicazione. Gli abusi comportano una sospensione.',
    editReview: 'Modifica recensione',
    submitReview: 'Invia recensione',
    evaluate: 'Valuta',
    startConversation: (name) => `Inizio della conversazione con ${name}`,
    introduce: 'Presentati!',
    messagePlaceholder: 'Il tuo messaggio...',
    sent: 'Inviato',
    read: 'Visto',
    attachment: 'Allegato',
    youPrefix: 'Tu:',
    today: 'Oggi',
    yesterday: 'Ieri',
    needDraft: (subject) => `Bisogno: ${subject}\n\n`,
    needSubjectLabel: (subject) => `Oggetto del bisogno: ${subject}`,
    basicOnly: 'Messaggistica disponibile dal piano Basic',
    upgradeBasic: 'Passa al piano Basic →',
    deleteConversation: 'Elimina conversazione',
    deleteConversationAction: 'Elimina',
    deleteConversationConfirm: (name) => `Eliminare la conversazione con ${name}?`,
    deleteConversationError: 'Impossibile eliminare la conversazione al momento.',
    viewProfile: 'Vedi profilo →',
    viewProfileShort: 'Profilo',
    profileBasicOnly: 'Basic',
    deleteForAllConfirm: 'Eliminare questo messaggio per tutti?',
    deleteForMeConfirm: 'Eliminare questo messaggio solo per te?',
    fileTypeError: 'Tipo di file non autorizzato.\n\nFormati accettati: immagini, PDF, Word, Excel, PowerPoint.',
    fileSizeError: 'File troppo grande. Dimensione massima: 10 MB.',
    fileUploadError: 'Errore durante l’invio del file.',
    fileBlocked: '⚠️ File bloccato\n\nQuesta immagine non rispetta le regole di Hubbing. Scegli un’immagine professionale.',
    reviewBlocked: '⚠️ Recensione non inviata\n\nIl commento contiene contenuti inappropriati.',
    messageBlocked: '⚠️ Messaggio non inviato\n\nIl messaggio contiene contenuti inappropriati.',
    directContactBlocked: '⚠️ Contatti bloccati\n\nNumeri di telefono, email e link esterni non possono essere scambiati nella messaggistica Hubbing. Continuate la conversazione direttamente nell’app.',
    starterDailyLimit: (remaining, max) => remaining > 0
      ? `Starter: ${remaining}/${max} messaggi rimasti oggi`
      : 'Starter: limite giornaliero raggiunto',
    starterLimitReached: 'Limite giornaliero raggiunto.\n\nHai inviato i tuoi 5 messaggi gratuiti di oggi. Passa a Basic o Premium per messaggiare senza limiti.',
    starterLimitPlaceholder: 'Limite giornaliero raggiunto',
    messageTooLong: (limit) => `Messaggio troppo lungo.\n\nQuesto piano consente massimo ${limit} caratteri per messaggio.`,
  },
  pricing: {
    title: 'Scegli il tuo piano',
    subtitle: 'Sviluppa la tua rete B2B in Svizzera',
    recommended: 'CONSIGLIATO',
    recommendedPlain: 'CONSIGLIATO',
    footer: 'Disdicibile in qualsiasi momento · Pagamento sicuro · Solo CHF',
    appleFooter: 'Disdicibile in qualsiasi momento · Pagamento tramite App Store · Solo CHF',
    androidFooter: 'Annullabile in qualsiasi momento · Pagamento tramite Google Play · Solo CHF',
    legalLinksTitle: 'Informazioni legali sugli abbonamenti',
    termsOfUseEula: 'Condizioni d’uso (EULA)',
    privacyPolicyLink: 'Informativa sulla privacy',
    restorePurchases: 'Ripristina acquisti',
    purchasePending: 'Il tuo acquisto è in attesa di conferma.',
    purchaseRestored: 'Acquisti ripristinati con successo.',
    noPurchaseToRestore: 'Nessun abbonamento attivo trovato.',
    appleProductsUnavailable: 'Gli abbonamenti Apple non sono ancora disponibili. Verifica i prodotti in App Store Connect.',
    androidBillingUnavailable: 'Gli abbonamenti Google Play non sono ancora disponibili. Verifica i prodotti in Play Console.',
    androidVerificationFailed: 'Google Play non ha potuto confermare questo abbonamento. Riprova o ripristina gli acquisti.',
    downgradeScheduled: 'Il passaggio a Basic è programmato per la prossima data di fatturazione.',
    purchaseSuccess: (plan) => `Abbonamento ${plan} attivato con successo!`,
    purchaseError: (message) => `Si è verificato un errore: ${message}`,
    testModeTitle: 'Modalità test abbonamento',
    testModeDesc: 'Cambia piano senza pagamento per verificare i limiti Starter, Basic e Premium.',
    testModeSuccess: (plan) => `Modalità test: ${plan} attivato.`,
    starterFeatures: ['Profilo aziendale', '5 swipe al giorno', '5 messaggi/giorno · 100 caratteri/messaggio', 'Ricezione messaggi illimitata', 'Visibile sulla mappa'],
    starterLimits: ['Indirizzo completo nascosto', 'Telefono, sito web e LinkedIn nascosti', 'Allegati non inclusi'],
    basicFeatures: ['Swipe illimitati', 'Messaggi illimitati · 1000 caratteri/messaggio', 'Indirizzo aziendale visibile', 'Ricezione messaggi illimitata', 'Statistiche di base'],
    basicLimits: ['Telefono, sito web e LinkedIn nascosti', 'Allegati non inclusi'],
    premiumFeatures: ['Tutto Basic incluso', 'Messaggi fino a 2000 caratteri', 'Contatti completi', 'Sito web e LinkedIn visibili', 'Allegati nei messaggi', 'Visibilità prioritaria'],
    premiumLimits: [],
    chooseBasic: 'Scegli Basic',
    choosePremium: 'Scegli Premium',
  },
  companyProfile: {
    featureBasic: 'Funzione Basic',
    upgradeDesc: 'Passa a Basic o Premium per messaggiare senza limiti e vedere più dettagli aziendali.',
    profileBasicOnlyTitle: 'Profilo dettagliato riservato agli abbonati',
    profileBasicOnlyDesc: 'Passa a Basic o Premium per vedere il profilo completo, l’indirizzo, i bisogni e le informazioni utili di questa azienda.',
    profileBasicOnlyCta: 'Vedi i piani →',
    inactive: '⚠️ Azienda inattiva',
    reviews: (count) => `(${count} recensioni)`,
    collaborations: 'Collaborazioni riuscite',
    about: 'CHI SIAMO',
    needs: 'BISOGNI',
    upgradeForNeeds: <>Starter include <strong>5 messaggi inviati al giorno</strong></>,
    answerNeed: 'Rispondi a questo bisogno →',
    decisionMaker: 'RESPONSABILE',
    photoLinkedInPremium: 'Foto e LinkedIn disponibili con Premium',
    availableBasic: <>Disponibile dal piano <strong>Basic</strong></>,
    information: 'INFORMAZIONI',
    ide: 'IDE',
    city: 'Città',
    address: 'Indirizzo',
    website: 'Sito web',
    addressBasic: 'Indirizzo completo disponibile da Basic',
    websitePremium: 'Sito web disponibile con Premium',
    fullContactPremium: 'Contatti diretti disponibili con Premium',
    connecting: 'Connessione...',
    contact: (name) => `🤝 Match / contatta ${name}`,
    basicMessaging: 'Starter: 5 messaggi inviati al giorno · Basic: messaggi illimitati',
    reportProfile: '🚩 Segnala questo profilo',
    reportTitle: 'Segnala questo profilo',
    reportReason: 'Motivo della segnalazione *',
    reportDetails: 'Dettagli aggiuntivi (opzionale)...',
    reportNote: 'Il nostro team esaminerà la segnalazione entro 48 ore. Le segnalazioni false possono comportare una sospensione.',
    sendReport: 'Invia segnalazione',
    reportSent: '✅ Segnalazione inviata. Il nostro team esaminerà questo profilo entro 48 ore.',
    reportError: 'Impossibile inviare la segnalazione. I dati inseriti sono stati conservati. Riprova.',
    reportAuthError: 'Impossibile verificare la connessione. Accedi nuovamente e riprova.',
    reportCompanyMissing: 'È necessario un profilo aziendale per inviare una segnalazione.',
    reasons: [
      { value: 'fake_profile', label: '🚫 Profilo falso / furto d’identità' },
      { value: 'abusive_behavior', label: '⚠️ Comportamento abusivo o molesto' },
      { value: 'inappropriate_message', label: '🔞 Messaggio inappropriato o sessuale' },
      { value: 'spam', label: '📧 Spam o contenuto commerciale abusivo' },
      { value: 'other', label: '❓ Altro' },
    ],
  },
  profile: {
    editTitle: 'Modifica profilo',
    company: 'AZIENDA',
    companyName: 'Nome azienda *',
    sector: 'Settore di attività',
    city: 'Città',
    address: 'Indirizzo completo *',
    description: 'Descrizione azienda...',
    serviceTags: {
      title: 'SERVIZI OFFERTI',
      help: 'Aggiungi fino a 10 servizi per ricevere richieste pertinenti.',
      placeholder: 'Pittura, Giardinaggio, Contabilità...',
      add: 'Aggiungi',
      limit: 'Massimo 10 servizi',
    },
    website: 'Sito web (https://...)',
    contact: 'RESPONSABILE / CONTATTO PRINCIPALE',
    contactName: 'Nome e cognome *',
    contactTitle: 'Titolo (CEO, Direttore, Gestore...)',
    contactPhone: 'Telefono diretto *',
    phoneRequired: 'Il telefono diretto è obbligatorio.',
    descriptionContactBlocked: 'Numeri di telefono, email, link LinkedIn e siti web non possono essere inseriti nella descrizione. Usa i campi previsti per rispettare la visibilità legata agli abbonamenti.',
    contactLinkedin: 'LinkedIn (https://linkedin.com/in/...)',
    contactPhoto: 'Foto del responsabile:',
    choosePhoto: 'Scegli una foto',
    needs: 'RICERCA PERMANENTE',
    needsHelp: 'Descrivi i partner o le collaborazioni che cerchi durante tutto l’anno. Nessuna data necessaria.',
    punctualNeeds: 'BISOGNI PUNTUALI',
    punctualNeedsHelp: 'Pubblica una richiesta precisa con data di inizio e scadenza.',
    startDate: 'Data di inizio',
    endDate: 'Scadenza',
    datesRequired: 'Scegli una data di inizio e una scadenza.',
    noDeadline: 'Senza scadenza',
    tagPlaceholder: 'Es: Ingegnere civile, Elettricista, Contabile...',
    add: '+ Aggiungi',
    expiryOptional: 'La data di scadenza è opzionale',
    notifications: 'NOTIFICHE',
    appNotif: '🔔 Notifiche nell’app',
    appNotifDesc: 'Nuovi match, messaggi, avvisi',
    emailNotif: '📧 Notifiche email',
    emailNotifDesc: 'Riepilogo attività via email',
    security: 'SICUREZZA',
    passwordHelp: 'Modifica la password dell’account Hubbing. Dopo il cambio verrà inviata un’email di sicurezza all’indirizzo del conto.',
    newPassword: 'Nuova password',
    confirmPassword: 'Conferma nuova password',
    changePassword: 'Modifica password',
    passwordChanging: 'Modifica...',
    passwordMinLength: 'La password deve contenere almeno 8 caratteri.',
    passwordMismatch: 'Le due password non corrispondono.',
    passwordUpdated: 'Password modificata. È stata inviata un’email di sicurezza.',
    passwordUpdatedEmailFailed: 'Password modificata, ma l’email di sicurezza non ha potuto essere inviata.',
    passwordUpdateError: (message) => `Impossibile modificare la password: ${message}`,
    updated: '✓ Profilo aggiornato!',
    background: 'Sfondo',
    downloading: 'Caricamento...',
    matches: 'Match',
    messages: 'Messaggi',
    collaborations: 'Collaborazioni',
    myPlan: 'Il mio piano →',
    about: 'CHI SIAMO',
    companyInfo: 'INFORMAZIONI AZIENDALI',
    zefix: 'Numero IDE',
    email: 'Email',
    editProfile: 'Modifica il mio profilo',
    previewCard: 'Vedi il mio profilo come gli altri',
    previewTitle: 'La tua scheda vista dagli altri',
    previewHelp: 'Anteprima della tua scheda in Swipe.',
    previewBadge: 'ANTEPRIMA',
    contactHubbing: '✉️ Contatta Hubbing',
    deleteAccount: 'Elimina il mio account',
    warningTitle: '⚠️ Attenzione',
    warningText: 'Stai per eliminare il tuo account Hubbing. Questa azione eliminerà definitivamente profilo, match e messaggi. Potrai registrarti di nuovo più tardi con la stessa email.',
    appleSubscriptionNotice: 'Importante: Hubbing non può annullare automaticamente un abbonamento App Store. Se hai un abbonamento Apple attivo, annullalo nella gestione abbonamenti Apple.',
    manageAppleSubscription: 'Gestisci abbonamento Apple',
    abandon: 'Annulla',
    continue: 'Continua',
    finalConfirm: '🔴 Conferma finale',
    finalConfirmText: (email) => <>Il tuo account sarà eliminato definitivamente e l’email <strong>{email}</strong> potrà essere riutilizzata per una futura registrazione.</>,
    confirm: 'Conferma',
    requestSent: '✅ Account eliminato',
    requestSentText: (email) => `L’account collegato a ${email} è stato eliminato. Verrai disconnesso.`,
    unknown: 'Sconosciuto',
    deleteError: 'Si è verificato un errore.',
    uploadError: 'Errore durante il caricamento.',
    imageTypeError: 'Scegli un’immagine valida.',
    imageSizeError: 'Immagine troppo grande. Dimensione massima: 10 MB.',
    imageBlocked: '⚠️ Immagine rifiutata\n\nQuesta immagine non rispetta le regole di Hubbing. Paesaggi, loghi, edifici e foto professionali sono autorizzati.',
    expired: '⚠️ Scaduto',
    expiresToday: '⏰ Scade oggi',
    daysLeft: (days) => `⏰ ${days}g rimanenti`,
    until: (date) => `✓ fino al ${date}`,
  },
  privacy: {
    title: 'Politica sulla privacy',
    updated: 'Ultimo aggiornamento: 22 aprile 2026',
    introTitle: '1. Introduzione',
    intro: 'Hubbing attribuisce grande importanza alla protezione dei dati personali. Questa politica descrive come raccogliamo, utilizziamo e proteggiamo i dati nell’app Hubbing.',
    controllerTitle: '2. Titolare del trattamento',
    controller: 'Hubbing — Svizzera',
    contact: 'Contatto: contact@hubbing.ch',
    dataTitle: '3. Dati raccolti',
    data: ['Informazioni del profilo aziendale', 'Dati di contatto e indirizzo email', 'Dati di connessione', 'Dati di utilizzo: swipe, match e messaggi', "Dati di pagamento legati all'abbonamento"],
    useTitle: '4. Finalità del trattamento',
    use: ['Creare e gestire l’account aziendale', 'Mostrare il profilo agli altri membri', 'Consentire matching e messaggistica B2B', 'Elaborare i pagamenti', 'Migliorare i servizi'],
    rightsTitle: '5. I tuoi diritti',
    rights: 'Puoi richiedere accesso, rettifica o cancellazione dei dati scrivendo a contact@hubbing.ch.',
  },
})

Object.assign(dictionaries.en, {
  needDetails: {
    title: 'Need details',
    publishedOn: 'Published on',
    startsOn: 'Start date',
    endsOn: 'Deadline',
    photos: 'PHOTOS AND DOCUMENTS',
    noPhotos: 'No photos attached to this need.',
    loadingPhotos: 'Loading photos...',
    contact: 'Contact by message',
    contacting: 'Opening...',
    ownNeed: 'This is your own need.',
    information: 'Need information',
    permanent: 'Ongoing search',
    punctual: 'Current need',
    noDeadline: 'No deadline',
  },
  home: {
    morning: 'Good morning',
    afternoon: 'Good afternoon',
    evening: 'Good evening',
    companiesOnHubbing: (count) => `${count} companies on Hubbing`,
    followingLabel: 'Following',
    followersLabel: 'Followers',
    collaborationsLabel: 'Successes',
    followersTitle: 'Companies following me',
    followingTitle: 'Companies I follow',
    noFollowers: 'Nobody follows you yet',
    noFollowing: 'You do not follow any company yet',
    viewAll: 'View all →',
    noConnections: 'No connections yet',
    discoverCompanies: 'Discover companies',
    completeProfile: 'Complete your profile',
    completeProfileDesc: 'A complete profile attracts 3x more matches',
    discoverTitle: 'Discover companies',
    discoverDesc: 'Swipe and create B2B connections',
    opportunitiesTitle: 'Your B2B opportunities right now',
    opportunitiesAllowance: (limit, plan) => limit ? `${limit} visible opportunities / week · ${plan}` : `Unlimited opportunities · ${plan}`,
    opportunitiesFilter: 'Filter',
    opportunitiesFilterTitle: 'Filter opportunities',
    opportunitiesFilterCount: (count) => `${count} opportunit${count > 1 ? 'ies' : 'y'} found`,
    opportunitiesKeyword: 'Keyword',
    opportunitiesKeywordPlaceholder: 'Ex: signage, accounting, renovation...',
    opportunitiesRadius: (radius) => `Radius: ${radius >= 300 ? 'All Switzerland' : `${radius} km`}`,
    opportunitiesSector: 'Sector',
    opportunitiesAllSectors: 'All sectors',
    opportunitiesCanton: 'Canton',
    opportunitiesAllCantons: 'All cantons',
    opportunitiesReset: 'Reset',
    opportunitiesShowResults: (count) => `Show ${count} result${count > 1 ? 's' : ''}`,
    opportunitiesEmpty: 'Nothing to show right now',
    opportunitiesEmptyDesc: 'Stay alert: matching needs will appear here as soon as a company publishes an opportunity.',
    opportunitiesUpgradeHint: (count) => `${count} more opportunit${count > 1 ? 'ies' : 'y'} with a higher plan →`,
    opportunityNeed: 'Need',
    opportunityDistance: (km) => `${km} km`,
    opportunityAttachments: (count) => `${count} file${count > 1 ? 's' : ''}`,
  },
  map: {
    createAccount: 'Create an account →',
    login: 'Log in →',
    searchPlaceholder: 'Search company, sector, city...',
    allCantons: 'All cantons',
    allSectors: (count) => `All sectors (${count} companies)`,
    viewProfile: 'View profile →',
    profileShort: 'Profile',
    directions: 'Directions',
    closeDetails: 'Close company card',
    addressUnavailable: 'Address unavailable',
    straightLineDistance: 'Straight-line distance from your company',
    approximateDistance: 'Estimated straight-line distance from your company',
    distanceUnavailable: 'Distance from your company unavailable',
    profileBasicOnly: 'Detailed profile from Basic →',
    createAccountToContact: (name) => `Create an account to contact ${name} →`,
    registeredCount: (count) => `${count} compan${count > 1 ? 'ies' : 'y'} registered on Hubbing`,
    filteredCount: (visible, total) => visible === total ? `${total} compan${total > 1 ? 'ies' : 'y'} on the map` : `${visible} / ${total} compan${total > 1 ? 'ies' : 'y'} on the map`,
    approximatePosition: 'Approximate position',
    standardView: 'Map',
    satelliteView: 'Satellite',
    radius: (radius) => `Radius: ${radius >= 300 ? 'All Switzerland' : `${radius} km`}`,
    radiusButton: (radius) => radius >= 300 ? 'Swiss' : `${radius} km`,
    allSwitzerland: 'All Switzerland',
    radiusNeedsLocation: 'Enable your location or save your profile to filter by radius.',
    useMyLocation: 'Use my location',
    myLocation: 'My location',
    meLabel: 'ME',
    locating: 'Locating...',
    locationDenied: 'Location denied. You can enable it in your browser or iPhone settings.',
    locationUnavailable: 'Location unavailable right now.',
  },
  swipe: {
    noResults: 'No results for these filters',
    allSeen: 'You have seen everything!',
    noResultsDesc: 'Try widening the radius, changing sector or searching another need.',
    allSeenDesc: 'You have browsed all available companies.',
    clearFilters: 'Clear filters',
    reviewAll: 'Review all from the start',
    newOnly: 'Show new only',
    matchSent: 'Match sent!',
    matchAlreadyExists: 'Match already exists',
    createAccountTitle: 'Create an account!',
    signupToSave: 'Sign up to save this match.',
    createAccount: 'Create an account →',
    login: 'Log in →',
    continueVisitor: 'Continue as visitor',
    filters: 'Filters',
    needsSearch: 'Search by need',
    needsSearchPlaceholder: 'Ex: resin, accountant, website...',
    radius: (radius) => `Radius: ${radius >= 300 ? 'All Switzerland' : `${radius} km`}`,
    allSwitzerland: 'All Switzerland',
    saveProfileRadius: '⚠️ Save your profile to enable the radius filter',
    sector: 'Sector',
    allSectors: 'All sectors',
    canton: 'Canton',
    allCantons: 'All cantons',
    clear: 'Clear',
    apply: (count) => `Apply (${count} results)`,
    applyNoCount: 'Apply',
    discovery: 'Discovery',
    visitorMode: '👀 Visitor mode — ',
    visitorCreate: 'Create an account',
    visitorSuffix: ' to save your matches',
    filtersButton: '🎛 Filters',
    previousCard: 'Previous card',
    viewProfile: 'View profile',
    shareProfile: 'Share profile',
    pass: 'Pass',
    match: 'Match',
    newLabel: 'New',
    needs: 'NEEDS',
    pressCheck: 'Tap ✓ to create an account',
  },
  messages: {
    title: 'Messages',
    subtitle: 'Your B2B connections',
    searchPlaceholder: 'Search a company...',
    noSearchResults: 'No conversation found',
    searchHint: 'Try the name, sector, city or a word from the latest message.',
    noConnections: 'No connections yet',
    noConnectionsDesc: 'Swipe companies to start conversations!',
    reviewTitle: (name) => `Review ${name}`,
    ratingLabel: 'Overall rating *',
    commentOptional: 'Comment (optional)',
    commentPlaceholder: 'Describe your experience with this company...',
    moderation: '⚠️ Your review will be moderated before publication. Abuse may lead to suspension.',
    editReview: 'Edit my review',
    submitReview: 'Submit my review',
    evaluate: 'Review',
    startConversation: (name) => `Conversation started with ${name}`,
    introduce: 'Introduce yourself!',
    messagePlaceholder: 'Your message...',
    sent: 'Sent',
    read: 'Seen',
    attachment: 'Attachment',
    youPrefix: 'You:',
    today: 'Today',
    yesterday: 'Yesterday',
    needDraft: (subject) => `Need: ${subject}\n\n`,
    needSubjectLabel: (subject) => `Need subject: ${subject}`,
    basicOnly: 'Messaging is available from the Basic plan',
    upgradeBasic: 'Upgrade to Basic →',
    deleteConversation: 'Delete conversation',
    deleteConversationAction: 'Delete',
    deleteConversationConfirm: (name) => `Delete the conversation with ${name}?`,
    deleteConversationError: 'Unable to delete the conversation right now.',
    viewProfile: 'View profile →',
    viewProfileShort: 'Profile',
    profileBasicOnly: 'Basic',
    deleteForAllConfirm: 'Delete this message for everyone?',
    deleteForMeConfirm: 'Delete this message only for you?',
    fileTypeError: 'File type not allowed.\n\nAccepted formats: images, PDF, Word, Excel, PowerPoint.',
    fileSizeError: 'File too large. Maximum size: 10 MB.',
    fileUploadError: 'Error while sending the file.',
    fileBlocked: '⚠️ File blocked\n\nThis image does not comply with Hubbing rules. Please choose a professional image.',
    reviewBlocked: '⚠️ Review not submitted\n\nYour comment contains inappropriate content.',
    messageBlocked: '⚠️ Message not sent\n\nYour message contains inappropriate content.',
    directContactBlocked: '⚠️ Contact details blocked\n\nPhone numbers, emails and external links cannot be exchanged in Hubbing messages. Keep the conversation inside the app.',
    starterDailyLimit: (remaining, max) => remaining > 0
      ? `Starter: ${remaining}/${max} messages left today`
      : 'Starter: daily limit reached',
    starterLimitReached: 'Daily limit reached.\n\nYou have sent your 5 free messages today. Upgrade to Basic or Premium to message without limits.',
    starterLimitPlaceholder: 'Daily limit reached',
    messageTooLong: (limit) => `Message too long.\n\nThis plan allows up to ${limit} characters per message.`,
  },
  pricing: {
    title: 'Choose your plan',
    subtitle: 'Grow your B2B network in Switzerland',
    recommended: 'RECOMMENDED',
    recommendedPlain: 'RECOMMENDED',
    footer: 'Cancel anytime · Secure payment · CHF only',
    appleFooter: 'Cancel anytime · App Store payment · CHF only',
    androidFooter: 'Cancel anytime · Google Play payment · CHF only',
    legalLinksTitle: 'Subscription legal information',
    termsOfUseEula: 'Terms of Use (EULA)',
    privacyPolicyLink: 'Privacy Policy',
    restorePurchases: 'Restore purchases',
    purchasePending: 'Your purchase is pending confirmation.',
    purchaseRestored: 'Purchases restored successfully.',
    noPurchaseToRestore: 'No active subscription found.',
    appleProductsUnavailable: 'Apple subscriptions are not available yet. Check the products in App Store Connect.',
    androidBillingUnavailable: 'Google Play subscriptions are not available yet. Check the products in Play Console.',
    androidVerificationFailed: 'Google Play could not confirm this subscription. Try again or restore your purchases.',
    downgradeScheduled: 'Your switch to Basic is scheduled for the next billing date.',
    purchaseSuccess: (plan) => `${plan} subscription activated successfully!`,
    purchaseError: (message) => `An error occurred: ${message}`,
    testModeTitle: 'Subscription test mode',
    testModeDesc: 'Switch plans without payment to check Starter, Basic and Premium limits.',
    testModeSuccess: (plan) => `Test mode: ${plan} enabled.`,
    starterFeatures: ['Company profile', '5 swipes per day', '5 messages/day · 100 characters/message', 'Unlimited message reception', 'Visible on the map'],
    starterLimits: ['Full address hidden', 'Phone, website and LinkedIn hidden', 'No attachments'],
    basicFeatures: ['Unlimited swipes', 'Unlimited messages · 1000 characters/message', 'Company address visible', 'Unlimited message reception', 'Basic statistics'],
    basicLimits: ['Phone, website and LinkedIn hidden', 'No attachments'],
    premiumFeatures: ['Everything in Basic', 'Messages up to 2000 characters', 'Full contact details', 'Website and LinkedIn visible', 'Message attachments', 'Priority visibility'],
    premiumLimits: [],
    chooseBasic: 'Choose Basic',
    choosePremium: 'Choose Premium',
  },
  companyProfile: {
    featureBasic: 'Basic feature',
    upgradeDesc: 'Upgrade to Basic or Premium to message without limits and access more company details.',
    profileBasicOnlyTitle: 'Detailed profile reserved for subscribers',
    profileBasicOnlyDesc: 'Upgrade to Basic or Premium to view the full profile, address, needs and useful information for this company.',
    profileBasicOnlyCta: 'See plans →',
    inactive: '⚠️ Company inactive',
    reviews: (count) => `(${count} reviews)`,
    collaborations: 'Successful collaborations',
    about: 'ABOUT',
    needs: 'NEEDS',
    upgradeForNeeds: <>Starter includes <strong>5 sent messages per day</strong></>,
    answerNeed: 'Answer this need →',
    decisionMaker: 'DECISION MAKER',
    photoLinkedInPremium: 'Photo and LinkedIn available with Premium',
    availableBasic: <>Available from the <strong>Basic</strong> plan</>,
    information: 'INFORMATION',
    ide: 'IDE',
    city: 'City',
    address: 'Address',
    website: 'Website',
    addressBasic: 'Full address available from Basic',
    websitePremium: 'Website available with Premium',
    fullContactPremium: 'Direct contact details available with Premium',
    connecting: 'Connecting...',
    contact: (name) => `🤝 Match / contact ${name}`,
    basicMessaging: 'Starter: 5 sent messages per day · Basic: unlimited messages',
    reportProfile: '🚩 Report this profile',
    reportTitle: 'Report this profile',
    reportReason: 'Reason for report *',
    reportDetails: 'Additional details (optional)...',
    reportNote: 'Our team will review this report within 48 hours. False reports may lead to account suspension.',
    sendReport: 'Send report',
    reportSent: '✅ Report sent. Our team will review this profile within 48 hours.',
    reportError: 'Could not send the report. Your entries have been kept. Please try again.',
    reportAuthError: 'Could not verify your sign-in. Please sign in again and retry.',
    reportCompanyMissing: 'You need a company profile to send a report.',
    reasons: [
      { value: 'fake_profile', label: '🚫 Fake profile / identity theft' },
      { value: 'abusive_behavior', label: '⚠️ Abusive or harassing behavior' },
      { value: 'inappropriate_message', label: '🔞 Inappropriate or sexual message' },
      { value: 'spam', label: '📧 Spam or abusive commercial content' },
      { value: 'other', label: '❓ Other' },
    ],
  },
  profile: {
    editTitle: 'Edit profile',
    company: 'COMPANY',
    companyName: 'Company name *',
    sector: 'Business sector',
    city: 'City',
    address: 'Full address *',
    description: 'Company description...',
    serviceTags: {
      title: 'SERVICES OFFERED',
      help: 'Add up to 10 services to receive the most relevant business needs.',
      placeholder: 'Painting, Gardening, Accounting...',
      add: 'Add',
      limit: 'Maximum 10 services',
    },
    website: 'Website (https://...)',
    contact: 'DECISION MAKER / MAIN CONTACT',
    contactName: 'Full name *',
    contactTitle: 'Title (CEO, Director, Manager...)',
    contactPhone: 'Direct phone *',
    phoneRequired: 'The direct phone number is required.',
    descriptionContactBlocked: 'Phone numbers, emails, LinkedIn links and websites cannot be added to the description. Please use the dedicated fields so visibility follows the selected subscription.',
    contactLinkedin: 'LinkedIn (https://linkedin.com/in/...)',
    contactPhoto: 'Decision maker photo:',
    choosePhoto: 'Choose a photo',
    needs: 'ONGOING SEARCH',
    needsHelp: 'Describe the partners or collaborations you are looking for throughout the year. No date is required.',
    punctualNeeds: 'CURRENT NEEDS',
    punctualNeedsHelp: 'Post a specific request with a start date and deadline.',
    startDate: 'Start date',
    endDate: 'Deadline',
    datesRequired: 'Choose a start date and a deadline.',
    noDeadline: 'No deadline',
    tagPlaceholder: 'Ex: Civil engineer, Electrician, Accountant...',
    add: '+ Add',
    expiryOptional: 'The due date is optional',
    notifications: 'NOTIFICATIONS',
    appNotif: '🔔 In-app notifications',
    appNotifDesc: 'New matches, messages, alerts',
    emailNotif: '📧 Email notifications',
    emailNotifDesc: 'Activity summary by email',
    security: 'SECURITY',
    passwordHelp: 'Change the Hubbing account password. A security email will be sent to the account address after the change.',
    newPassword: 'New password',
    confirmPassword: 'Confirm new password',
    changePassword: 'Change password',
    passwordChanging: 'Changing...',
    passwordMinLength: 'The password must contain at least 8 characters.',
    passwordMismatch: 'The two passwords do not match.',
    passwordUpdated: 'Password changed. A security email has been sent.',
    passwordUpdatedEmailFailed: 'Password changed, but the security email could not be sent.',
    passwordUpdateError: (message) => `Unable to change password: ${message}`,
    updated: '✓ Profile updated!',
    background: 'Cover',
    downloading: 'Uploading...',
    matches: 'Matches',
    messages: 'Messages',
    collaborations: 'Collaborations',
    myPlan: 'My plan →',
    about: 'ABOUT',
    companyInfo: 'COMPANY INFORMATION',
    zefix: 'IDE number',
    email: 'Email',
    editProfile: 'Edit my profile',
    previewCard: 'View my profile as others do',
    previewTitle: 'Your card as others see it',
    previewHelp: 'Preview of your card in Swipe.',
    previewBadge: 'PREVIEW',
    contactHubbing: '✉️ Contact Hubbing',
    deleteAccount: 'Delete my account',
    warningTitle: '⚠️ Warning',
    warningText: 'You are about to delete your Hubbing account. This action will permanently delete your profile, matches and messages. You can register again later with the same email.',
    appleSubscriptionNotice: 'Important: Hubbing cannot automatically cancel an App Store subscription. If you have an active Apple subscription, cancel it in Apple subscription management.',
    manageAppleSubscription: 'Manage Apple subscription',
    abandon: 'Cancel',
    continue: 'Continue',
    finalConfirm: '🔴 Final confirmation',
    finalConfirmText: (email) => <>Your account will be permanently deleted and <strong>{email}</strong> can be reused for a future registration.</>,
    confirm: 'Confirm',
    requestSent: '✅ Account deleted',
    requestSentText: (email) => `The account linked to ${email} has been deleted. You will be signed out.`,
    unknown: 'Unknown',
    deleteError: 'An error occurred.',
    uploadError: 'Upload error.',
    imageTypeError: 'Please choose a valid image.',
    imageSizeError: 'Image too large. Maximum size: 10 MB.',
    imageBlocked: '⚠️ Image rejected\n\nThis image does not comply with Hubbing rules. Landscapes, logos, buildings and professional photos are allowed.',
    expired: '⚠️ Expired',
    expiresToday: '⏰ Expires today',
    daysLeft: (days) => `⏰ ${days}d left`,
    until: (date) => `✓ until ${date}`,
  },
  privacy: {
    title: 'Privacy Policy',
    updated: 'Last updated: April 22, 2026',
    introTitle: '1. Introduction',
    intro: 'Hubbing takes the protection of your personal data seriously. This policy explains how we collect, use and protect your data in the Hubbing app.',
    controllerTitle: '2. Data controller',
    controller: 'Hubbing — Switzerland',
    contact: 'Contact: contact@hubbing.ch',
    dataTitle: '3. Data collected',
    data: ['Company profile information', 'Contact details and email address', 'Login data', 'Usage data: swipes, matches and messages', 'Payment data linked to your subscription'],
    useTitle: '4. Processing purposes',
    use: ['Create and manage your company account', 'Show your profile to other members', 'Enable B2B matching and messaging', 'Process payments', 'Improve our services'],
    rightsTitle: '5. Your rights',
    rights: 'You can request access, correction or deletion of your data by writing to contact@hubbing.ch.',
  },
})

const deepMerge = (base, override = {}) => {
  const output = Array.isArray(base) ? [...base] : { ...base }
  Object.keys(override).forEach((key) => {
    if (
      override[key] &&
      typeof override[key] === 'object' &&
      !Array.isArray(override[key]) &&
      typeof override[key] !== 'function' &&
      base[key] &&
      typeof base[key] === 'object' &&
      !Array.isArray(base[key])
    ) {
      output[key] = deepMerge(base[key], override[key])
    } else {
      output[key] = override[key]
    }
  })
  return output
}

export const localeForLang = (lang = 'fr') => ({
  fr: 'fr-CH',
  de: 'de-CH',
  it: 'it-CH',
  en: 'en-GB',
}[lang] || 'fr-CH')

export const getUiText = (lang = 'fr') => {
  const merged = deepMerge(dictionaries.fr, dictionaries[lang] || {})
  if (lang !== 'fr' && !dictionaries[lang]?.usageGuide?.usageGuidePages) {
    delete merged.usageGuide.usageGuidePages
  }
  return merged
}
